<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div id="topo" class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">{{ this.obterTitulo() }}</span>
                <br />
                <span class="navigation">{{ obterSubtitulo() }}</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <error-list :erros="erros" />
          <cancelar-nota-fiscal />
          <copiar-nota-fiscal />
          <enviar-email-nota-fiscal />
          <tomador-cadastro tipoCadastro="T" />
          <remover-tomador tipoCadastro="T" />
          <remover-intermediario />
          <remover-destinatario />
          <obras-cadastro-dialog/>
          <imovel-cadastro-dialog/>


          <Message severity="warn" v-if="this.tipoCadastroInvalido">Inscrição do contribuinte não pertence ao cadastro municipal, não será possível emitir notas de serviço, contate o município!</Message>
          <Message severity="error" v-if="isEmissaoTesteValidacao">Atenção! Tela de Emissão para Testes e Validações!</Message>
          <Message severity="info" v-if="msgAvisoRegimeTribuNfse">{{ this.msgAvisoRegimeTribuNfse }}</Message>

          <div class="row" v-if="exibirDadosNotaSubstituida">
            <div class="col-md-10 mb-2">
              <Panel :toggleable="true" header="Dados da NFS-e Substituída">
                <div class="row">
                  <div class="col-3">
                    <b>Número:</b>
                    {{ dadosNotaSubstituida.numero }}
                  </div>
                  <div class="col-3">
                    <b>Data:</b>
                    {{ dadosNotaSubstituida.data }}
                  </div>
                  <div class="col-6">
                    <b>Tomador:</b>
                    {{ dadosNotaSubstituida.tomador }}
                  </div>
                </div>
              </Panel>
            </div>
          </div>

          <div id="dpsDadosId" tabindex="-1" class="row" v-if="dpsId && ((errosDps && errosDps.length > 0) || chaveAcesso)">
            <div class="col-md-10 mb-2">
              <Panel :toggleable="true" v-if="chaveAcesso" header="Transmissão Realizada com Sucesso">
                <div style="padding: 10px 0;">
                  <Message severity="success" :closable="false">
                    DPS transmitida com sucesso para o nota nacional chave acesso gerada: <strong>{{ chaveAcesso }}</strong>
                  </Message>
                </div>
              </Panel>
              <Panel :toggleable="true" v-if="!chaveAcesso && errosDps && errosDps.length > 0" header="Pendências / Erros de Transmissão da DPS Nacional">
                <div class="erros-dps-container">
                  <div v-for="(erro, index) in errosDps" :key="index" class="erro-dps-card mb-3">
                    <div class="erro-dps-header d-flex align-items-center justify-content-between">
                      <span class="erro-dps-code">
                        <i class="pi pi-exclamation-triangle mr-2"></i>
                        Código: <strong>{{ erro.codigo || 'N/A' }}</strong>
                      </span>
                    </div>
                    <div class="erro-dps-body mt-2">
                      <div class="erro-dps-desc">
                        {{ erro.descricao }}
                      </div>
                      <div v-if="erro.complemento" class="erro-dps-comp mt-2">
                        <span class="text-muted">Complemento:</span> {{ erro.complemento }}
                      </div>
                    </div>
                  </div>
                </div>
              </Panel>

              
            </div>
          </div>
          <div class="row d-flex align-items-end">
            <div class="col-md-3 mb-2" v-if="!isEmissaoTesteValidacao && !isEmissaoSoPorDPS && !this.dpsId">
              <label for="tipoDps" class="d-inline-flex align-items-center">Realizar emissão no modelo DPS com IBS/CBS?
                <Button 
                  class="pi pi-exclamation-circle p-button-rounded p-button-text p-button-sm" 
                  v-tooltip.right="tooltipText"
                  @click="showDlgIbsCbs = true"
                  style="margin-left: 5px; cursor: pointer; height: 20px !important; width: 20px !important; padding: 0 !important; min-width: 0 !important;"
                ></Button>
              </label>
              <span class="p-fluid">
                <Dropdown @change="alterarTipoDps()" id="tipoDps" v-model="selectedTipoEmissaoDps"
                  :options="tiposEmissaoDps" optionLabel="name" placeholder="Selecione um Tipo de Emissão"
                  :optionDisabled="desabilitarEdicaoCampos" :disabled="desabilitarEdicaoCampos || travarEdicaoTomador || travarCamposEmissaoLote" />
              </span>
            </div>
          </div>
          <div class="row d-flex align-items-end">
            <div class="col-md-2 mb-2" v-if="desabilitarEdicaoCampos">
              <label for="tipoTomador">Número:</label>
              <span class="p-fluid">
                <InputText v-model="notaFiscal.numero" disabled />
              </span>
            </div>

            <div class="col-md-2 mb-2">
              <label for="tipoTomador">Tipo Tomador:</label>
              <span class="p-fluid">
                <Dropdown @change="alterarTipoTomador()" id="tipoTomador" v-model="selectedTipoTomador"
                  :options="tiposTomador" optionLabel="name" placeholder="Selecione um Tipo de Tomador"
                  :optionDisabled="desabilitarEdicaoCampos" :disabled="desabilitarEdicaoCampos || travarEdicaoTomador || travarCamposEmissaoLote" />
              </span>
            </div>
            <div :class="desabilitarEdicaoCampos ? 'col-md-5 mb-2' : 'col-md-7 mb-2'">
              <label for="tomador">{{selectedTipoTomador.name + (selectedTipoTomador.key != "N" ? ": *" : ":")}}</label>
              <span class="p-fluid">
                <AutoComplete id="tomador" v-model="selectedPessoa" :dropdown="true" :suggestions="filteredPessoas"
                  @complete="searchPessoa($event)" @item-select="atualizarDadosPessoaSelecionada()" field="detail"
                  :placeholder="
                    selectedTipoTomador.key == 'N'
                      ? 'Não Identificado'
                      : 'Pesquisar'" 
                  :disabled="desabilitarEdicaoNomeTomador || travarEdicaoTomador || travarCamposEmissaoLote" 
                  :class="{'p-error': validation.hasError('selectedPessoa'),}">
                  <template #item="slotProps">
                    <div class="p-fluid" style="max-width: 50vw">
                      {{ slotProps.item.detail }}
                    </div>
                  </template>
                </AutoComplete>
              </span>
            </div>
            <div class="col-md-1 mb-2">
              <span class="p-fluid ml-2">
                <div class="p-inputgroup">
                  <Button @click="novoTomador()" id="btnNovoTomador" type="button" icon="pi pi-plus"
                    title="Cadastrar Tomador" :disabled="desabilitarBotaoNovoTomador || travarEdicaoTomador || travarCamposEmissaoLote" />
                  <Button @click="editarTomador()" id="btnEditarTomador" type="button" icon="pi pi-pencil"
                    title="Editar Tomador" :disabled="desabilitarBotaoEdicaoTomador || travarEdicaoTomador || travarCamposEmissaoLote" />
                  <Button @click="removerTomador()" id="btnRemoverTomador" type="button" icon="pi pi-trash"
                    title="Remover Tomador" :disabled="desabilitarBotaoRemoverTomador || travarEdicaoTomador || travarCamposEmissaoLote" />
                </div>
              </span>
            </div>
          </div>
          <detalhes-contribuinte tipoEmissao="P" />
          <div class="row d-flex align-items-end" v-if="exibeIntermediario">
            <div class="col-md-2 mb-2">
              <label for="exibirIntermediario">Informar Intermediário:</label>
              <span class="p-fluid">
                <Dropdown @change="alterarTipoIntermediario()" id="tipoIntermediario" v-model="selectedTipoIntermediario"
                  :options="tiposIntermediario" optionLabel="name" 
                  :optionDisabled="desabilitarEdicaoCampos" :disabled="desabilitarEdicaoCampos || travarEdicaoTomador || travarCamposEmissaoLote" />
              </span> 
            </div>
            <div class="col-md-7 mb-2" v-if="exibirSelecaoIntermediario">
              <label for="intermediario">Intermediário:</label>
              <span class="p-fluid">
                <!-- @item-select="atualizarDadosPessoaSelecionada()" -->
                <AutoComplete id="intermediario" v-model="selectedPessoaIntermediario" :dropdown="true" :suggestions="filteredPessoas"
                  @complete="searchPessoa($event)"  field="detail"
                  placeholder="Pesquisar" :disabled="desabilitarEdicaoNomeTomador || travarEdicaoTomador || travarCamposEmissaoLote" :class="{
  'p-error': validation.hasError('selectedPessoaIntermediario'),
}">
                  <template #item="slotProps">
                    <div class="p-fluid" style="max-width: 50vw">
                      {{ slotProps.item.detail }}
                    </div>
                  </template>
                </AutoComplete>
              </span>
            </div>
            <div class="col-md-1 mb-2" v-if="exibirSelecaoIntermediario">
              <span class="p-fluid ml-2">
                <div class="p-inputgroup">
                  <Button @click="novoIntermediario()" id="btnNovoIntermediario" type="button" icon="pi pi-plus"
                    title="Cadastrar Intermediário" :disabled="desabilitarBotaoNovoIntermediario || travarEdicaoTomador || travarCamposEmissaoLote" />
                  <Button @click="editarIntermediario()" id="btnEditarIntermediario" type="button" icon="pi pi-pencil"
                    title="Editar Intermediário" :disabled="desabilitarBotaoEdicaoIntermediario || travarEdicaoTomador || travarCamposEmissaoLote" />
                  <Button @click="removerIntermediario()" id="btnRemoverIntermediario" type="button" icon="pi pi-trash"
                    title="Remover Intermediario" :disabled="desabilitarBotaoRemoverIntermediario || travarEdicaoTomador || travarCamposEmissaoLote" />
                </div>
              </span>
            </div>
          </div>
          <detalhes-contribuinte tipoEmissao="I" />
          <div class="row d-flex align-items-end" v-if="isEmissaoTesteValidacao || isEmissaoPorDPS">
            <div class="col-md-2 mb-2">
              <label for="exibirDestinatario">Destinatário é o próprio tomador/adquirente?</label>
              <span class="p-fluid">
                <Dropdown @change="alterarTipoDestinatario()" id="tipoDestinatario" v-model="selectedTipoDestinatario"
                  :options="tiposDestinatario" optionLabel="name" 
                  :optionDisabled="desabilitarEdicaoCampos" :disabled="desabilitarEdicaoCampos || travarEdicaoTomador || travarCamposEmissaoLote" />
              </span> 
            </div>
            <div class="col-md-7 mb-2" v-if="exibirSelecaoDestinatario">
              <label for="destinatario">Destinatário:</label>
              <span class="p-fluid">
                <!-- @item-select="atualizarDadosPessoaSelecionada()" -->
                <AutoComplete id="destinatario" v-model="selectedPessoaDestinatario" :dropdown="true" :suggestions="filteredPessoas"
                  @complete="searchPessoa($event)"  field="detail"
                  placeholder="Pesquisar" :disabled="desabilitarEdicaoNomeTomador || travarEdicaoTomador || travarCamposEmissaoLote" :class="{
  'p-error': validation.hasError('selectedPessoaDestinatario'),
}">
                  <template #item="slotProps">
                    <div class="p-fluid" style="max-width: 50vw">
                      {{ slotProps.item.detail }}
                    </div>
                  </template>
                </AutoComplete>
              </span>
            </div>
            <div class="col-md-1 mb-2" v-if="exibirSelecaoDestinatario">
              <span class="p-fluid ml-2">
                <div class="p-inputgroup">
                  <Button @click="novoDestinatario()" id="btnnovoDestinatario" type="button" icon="pi pi-plus"
                    title="Cadastrar Destinatário" :disabled="desabilitarBotaoNovoDestinatario || travarEdicaoTomador || travarCamposEmissaoLote" />
                  <Button @click="editarDestinatario()" id="btneditarDestinatario" type="button" icon="pi pi-pencil"
                    title="Editar Destinatário" :disabled="desabilitarBotaoEdicaoDestinatario || travarEdicaoTomador || travarCamposEmissaoLote" />
                  <Button @click="removerDestinatario()" id="btnremoverDestinatario" type="button" icon="pi pi-trash"
                    title="Remover Destinatário" :disabled="desabilitarBotaoEdicaoDestinatario || travarEdicaoTomador || travarCamposEmissaoLote" />
                </div>
              </span>
            </div>
          </div>

          <detalhes-contribuinte tipoEmissao="D" />

          <div class="row" v-if="opcaoServicoAberto">
            <div class="col-md-3 mb-2 d-flex align-items-center">
              <label for="binary">Listar todos Serviços Municipais</label>
              <span class="p-fluid">
                <Checkbox style="margin-left:5px;" id="binary" v-model="checkServicoAberto" :binary="true" @change="clearServico()" />
              </span>
            </div>
          </div>

          <div class="row d-flex">
            <div class="col-md-2 mb-2">
              <label for="dataEmissao">Data Fato Gerador: *</label>
              <span class="p-fluid">
                <Calendar id="dataEmissao" name="dataEmissao" v-model="notaFiscal.dataFatoGerador"
                  :minDate="dataMinimaEmissao" :maxDate="dataMaximaEmissao" :showIcon="true" dateFormat="dd/mm/yy"
                  :disabled="desabilitarEdicaoCampos" :manualInput="false" @date-select="emissaoSelect()" />
              </span>
            </div>
            <div class="col-md-8 mb-2" v-if="isEmissaoPorServicoNacional && this.selectedServico && this.selectedServico.id">
              <label for="atividade">Serviço Municipal: *</label>
              <span class="p-fluid">
                <InputText v-model="this.selectedServico.detail" disabled="true" style="text-align: left;"/>
              </span>
            </div>
            <div class="col-md-8 mb-2" v-if="emissaoPorAtividade">
              <label for="atividade">Atividade: *</label>
              <span class="p-fluid">
                <AutoComplete id="atividade" v-model="selectedAtividade" :dropdown="true"
                  :suggestions="filteredAtividade" field="detail" placeholder="Pesquisar"
                  @complete="searchAtividade($event)" @item-select="atualizarServico()"
                  :disabled="desabilitarEdicaoCampos">
                  <template #item="slotProps">
                    <div class="p-fluid" style="max-width: 50vw">
                      {{ slotProps.item.codigo }} - {{ slotProps.item.nomeReduzidoAtividade }}
                    </div>
                  </template>
                </AutoComplete>
              </span>
            </div>
            
            <div :class="emissaoPorAtividade ? 'col-md-10 mb-2' : 'col-md-8 mb-2'" v-if="!isEmissaoPorServicoNacional">
              <label for="servico">Serviço Municipal: *</label>
              <span class="p-fluid">
                <AutoComplete id="servico" v-model="selectedServico" :dropdown="true" :suggestions="filteredServicos"
                  field="detail" placeholder="Pesquisar" @complete="searchServico($event)"
                  @item-select="atualizarValoresServico(true)" :disabled="desabilitarEdicaoCampos">
                  <template #item="slotProps">
                    <div class="p-fluid" style="max-width: 50vw">
                      {{ slotProps.item.detail }}
                    </div>
                  </template>
                </AutoComplete>
              </span>
            </div>
          </div>
          <div class="row d-flex align-items-end" v-if="isHabilitarNotaNacional && isEmissaoPorServicoNacional">
              <div class="col-md-10 mb-2">
                <label for="servicoNacional">Serviço Nacional: * </label>
                <span class="p-fluid">
                  <AutoComplete id="servicoNacional" v-model="selectedServicoNacional" :dropdown="true" :suggestions="filteredServicosNacionais"
                    field="detail" placeholder="Pesquisar" @complete="searchServicoNacionalCompleto($event)"
                    @item-select="atualizarDadosServicoNacional()"
                    :disabled="desabilitarEdicaoCampos">
                    <template #item="slotProps">
                      <div class="p-fluid" style="max-width: 50vw">
                        {{ slotProps.item.detail }}
                      </div>
                    </template>
                  </AutoComplete>
                </span>
              </div>
            </div>
          <div class="row d-flex align-items-end" v-if="isHabilitarNotaNacional && !isEmissaoPorServicoNacional">
            <div class="col-md-10 mb-2">
              <label for="servicoNacional">Serviço Nacional: * </label>
              <span class="p-fluid">
                <AutoComplete id="servicoNacional" v-model="selectedServicoNacional" :dropdown="true" :suggestions="filteredServicosNacionais"
                  field="detail" placeholder="Pesquisar" @complete="searchServicoNacional($event)"
                  @item-select="atualizarDadosTela()"
                  :disabled="desabilitarEdicaoCampos">
                  <template #item="slotProps">
                    <div class="p-fluid" style="max-width: 50vw">
                      {{ slotProps.item.detail }}
                    </div>
                  </template>
                </AutoComplete>
              </span>
            </div>
          </div>
          <div class="row d-flex align-items-end" v-if="habilitarSelecaoObra">
            <div class="col-md-8 mb-2">
              <label for="obra">Obra: </label>
              <span class="p-fluid">
                <AutoComplete id="obra" v-model="selectedObra" :dropdown="true" :suggestions="filteredObras"
                  field="detail" placeholder="Pesquisar" @complete="searchObra($event)"
                  @item-select="atualizarDadosObra()" :disabled="desabilitarEdicaoCampos">
                  <template #item="slotProps">
                    <div class="p-fluid" style="max-width: 50vw">
                      {{ slotProps.item.detail }}
                    </div>
                  </template>
                </AutoComplete>
              </span>
            </div>
             <div class="col-md-1 mb-2">
              <span class="p-fluid ml-2">
                <div class="p-inputgroup">
                  <Button @click="novaObra()" id="btnNovaObra" type="button" icon="pi pi-plus"
                    title="Cadastrar Obra" :disabled="desabilitarBotaoNovaObra || travarCamposEmissaoLote" />
                  <Button @click="editarObra()" id="btnEditarObra" type="button" icon="pi pi-pencil"
                    title="Editar Obra" :disabled="desabilitarBotaoEdicaoObra || travarCamposEmissaoLote" />
                  <Button @click="removerObra()" id="btnRemoverObra" type="button" icon="pi pi-trash"
                    title="Remover Obra" :disabled="desabilitarBotaoRemoverObra || travarCamposEmissaoLote" />
                </div>
              </span>
            </div>
          </div>
          <div class="row d-flex align-items-end" v-if="(isHabilitarNotaNacional || isEmissaoTesteValidacao)">
            <div class="col-md-10 mb-2">
              <label for="nbs">NBS: {{(isEmissaoTesteValidacao || isEmissaoPorDPS) ? '*' : ''}}</label>
              <span class="p-fluid">
                <AutoComplete id="nbs" v-model="selectedNbs" :dropdown="true" :suggestions="filteredNbs"
                  field="detail" placeholder="Pesquisar" @complete="searchNbs($event)"
                  :disabled="desabilitarEdicaoCampos">
                  <template #item="slotProps">
                    <div class="p-fluid" style="max-width: 50vw">
                      {{ slotProps.item.detail }}
                    </div>
                  </template>
                </AutoComplete>
              </span>
            </div>
          </div>
           <div class="row d-flex align-items-end" v-if="isHabilitarNotaNacional && (isEmissaoTesteValidacao || isEmissaoPorDPS)">
            <div class="col-md-10 mb-2">
              <label for="indop">Indicador de Operação: </label>
              <span class="p-fluid">
                <AutoComplete id="indop" v-model="selectedIndop" :dropdown="true" :suggestions="filteredIndop"
                  field="detail" placeholder="Pesquisar" @complete="searchIndop($event)" @item-select="indopSelecionado()" 
                  :disabled="desabilitarEdicaoCampos">
                  <template #item="slotProps">
                    <div class="p-fluid" style="max-width: 50vw">
                      {{ slotProps.item.detail }}
                    </div>
                  </template>
                </AutoComplete>
              </span>
            </div>
          </div>
          <div class="row d-flex align-items-end" v-if="exibirSelecaoImovel">
            <div class="col-md-8 mb-2">
              <label for="imovel">Imóvel: </label>
              <span class="p-fluid">
                <AutoComplete id="imovel" v-model="selectedImovel" :dropdown="true" :suggestions="filteredImoveis"
                  field="detail" placeholder="Pesquisar" @complete="searchImovel($event)"
                  :disabled="desabilitarEdicaoCampos">
                  <template #item="slotProps">
                    <div class="p-fluid" style="max-width: 50vw">
                      {{ slotProps.item.detail }}
                    </div>
                  </template>
                </AutoComplete>
              </span>
            </div>
             <div class="col-md-1 mb-2">
              <span class="p-fluid ml-2">
                <div class="p-inputgroup">
                  <Button @click="novoImovel()" id="btnnovoImovel" type="button" icon="pi pi-plus"
                    title="Cadastrar Imóvel" :disabled="desabilitarBotaoNovaImovel || travarCamposEmissaoLote" />
                  <Button @click="editarImovel()" id="btnEditarImovel" type="button" icon="pi pi-pencil"
                    title="Editar Imóvel" :disabled="desabilitarBotaoEdicaoImovel || travarCamposEmissaoLote" />
                  <Button @click="removerImovel()" id="btnRemoverImovel" type="button" icon="pi pi-trash"
                    title="Remover Imóvel" :disabled="desabilitarBotaoRemoverImovel || travarCamposEmissaoLote" />
                </div>
              </span>
            </div>
          </div>
          <div class="row d-flex align-items-end" v-if="isHabilitarNotaNacional && (isEmissaoTesteValidacao || isEmissaoPorDPS)">
            <div class="col-md-10 mb-2">
              <label for="classtrib">Classificação Tributária: </label>
              <span class="p-fluid">
                <AutoComplete id="classtrib" v-model="selectedClasstrib" :dropdown="true" :suggestions="filteredClasstrib"
                  field="detail" placeholder="Pesquisar" @complete="searchClasstrib($event)"
                  :disabled="desabilitarEdicaoCampos">
                  <template #item="slotProps">
                    <div class="p-fluid" style="max-width: 50vw">
                      {{ slotProps.item.detail }}
                    </div>
                  </template>
                </AutoComplete>
              </span>
            </div>
          </div>
          
          <div class="row d-flex align-items-end">
            <div class="col-md-2 mb-2">
              <label for="localPrestacao">Local Prestação:</label>
              <span class="p-fluid">
                <Dropdown id="localPrestacao" v-model="selectedLocalPrestacao" :options="locaisPrestacao"
                  optionLabel="name" placeholder="Selecione um Local de Prestação" @change="atualizarDadosTela()"
                  :optionDisabled="desabilitarEdicaoLocalPrestacao" :disabled="desabilitarEdicaoLocalPrestacao" />
              </span>
            </div>
            <div class="col-md-2 mb-2">
              <label for="tipoRec">Tipo Recolhimento:</label>
              <span class="p-fluid">
                <Dropdown id="tipoRec" name="tipoRec" v-model="selectedTipoRecolhimento" :options="tiposRecolhimento"
                  optionLabel="name" placeholder="Selecione um Tipo de Recolhimento"
                  :optionDisabled="desabilitarEdicaoNotaAvulsa" :disabled="desabilitarEdicaoNotaAvulsa" />
              </span>
            </div>
            <div class="col-md-3 mb-2">
              <label for="munic">Município Prestação: *</label>
              <span class="p-fluid">
                <AutoComplete id="munic" v-model="selectedMunicPrestacao" :dropdown="true"
                  :suggestions="filteredLocalidades" @complete="searchLocalidade($event)" @item-select="municPrestacaoSelecionado()" field="detail"
                  placeholder="Pesquisar" :disabled="desabilitarEdicaoMunicipio" />
              </span>
            </div>
            <div class="col-md-3 mb-2" v-if="servicoTributadoFora">
              <label for="tipoTributacao">Tributado no Município do Prestador?</label>
              <span class="p-fluid">
                <Dropdown id="tipoTributacao" name="tipoTributacao" v-model="selectedTipoTributacao" :options="tiposTributacao"
                  optionLabel="name" placeholder="Selecione um Tipo de Tributação" @change="municPrestacaoSelecionado()" :disabled="desabilitarEdicaoCampos"/>
              </span>
            </div>
            <div class="col-md-3 mb-2" v-if="codigoIbgeVal !== 9999999 || selectedLocalPrestacao.key === 'M'">
              <label for="municIncid">Município Recolhimento: </label>
              <span class="p-fluid">
                <InputText v-model="municipioIncidencia" disabled="true" style="text-align: left;"/>
              </span>
            </div>
            <div class="col-md-3 mb-2" v-if="exibirOpcaoExportacao">
              <label for="exportacao">Exportação de Serviços?</label>
              <span class="p-fluid">
                <Dropdown id="exportacao" name="exportacao" v-model="selectedExportacao" :options="tiposExportacao"
                  optionLabel="name" placeholder="Selecione uma opção" @change="atualizarDadosTela()" :disabled="desabilitarEdicaoCampos"/>
              </span>
            </div>
            <div class="col-md-3 mb-2" v-if="exibirPaisExportacao || ((codigoIbgeVal && codigoIbgeVal === 9999999) && (selectedLocalPrestacao && selectedLocalPrestacao.key === 'F'))">
              <label for="munic">{{exibirPaisExportacao ? 'País Resultado da Prestação de Serviço:' : 'País:'}} *</label>
              <span class="p-fluid">
                <AutoComplete id="munic" v-model="selectedPais" :dropdown="true" :suggestions="filteredPaises"
                  @complete="searchPais($event)" field="detail" placeholder="Pesquisar" :disabled="desabilitarEdicaoCampos"/>
              </span>
            </div>
          </div>
          <!-- Grupo de Campos: Comércio Exterior -->
          <div class="row" v-if="exibirComercioExterior">
            <div class="col-md-10 mb-2">
              <Panel header="Comércio Exterior">
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="comExtMdPrestacao">Modo de Prestação: *</label>
                    <span class="p-fluid">
                      <Dropdown id="comExtMdPrestacao" name="comExtMdPrestacao" v-model="selectedModoPrestacao" :options="modosPrestacao"
                        optionLabel="name" placeholder="Selecione o modo de prestação"
                        :disabled="desabilitarEdicaoCampos" :showClear="true"
                        :class="{ 'p-invalid': validarComex && (!selectedModoPrestacao || !selectedModoPrestacao.key) }" />
                    </span>
                  </div>

                  <div class="col-md-6 mb-2">
                    <label for="comExtVincPrest">Vínculo da Prestação: *</label>
                    <span class="p-fluid">
                      <Dropdown id="comExtVincPrest" name="comExtVincPrest" v-model="selectedVinculoPrestacao" :options="vinculosPrestacao"
                        optionLabel="name" placeholder="Selecione o vínculo da prestação"
                        :disabled="desabilitarEdicaoCampos" :showClear="true"
                        :class="{ 'p-invalid': validarComex && (!selectedVinculoPrestacao || !selectedVinculoPrestacao.key) }" />
                    </span>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="comExtTpMoeda">Moeda: *</label>
                    <span class="p-fluid">
                      <InputMask id="comExtTpMoeda" name="comExtTpMoeda" v-model="notaFiscal.comExtTpMoeda"
                        placeholder="Ex: 220, 470, 706, etc." mask="999" maxlength="3"
                        :disabled="desabilitarEdicaoCampos"
                        :class="{ 'p-invalid': validarComex && (!notaFiscal.comExtTpMoeda || !notaFiscal.comExtTpMoeda.trim()) }" />
                    </span>
                  </div>

                  <div class="col-md-3 mb-2">
                    <label for="comExtVServMoeda">Valor Serv. em Moeda: *</label>
                    <span class="p-fluid">
                      <money id="comExtVServMoeda" name="comExtVServMoeda" v-model="notaFiscal.comExtVServMoeda" v-bind="moneySemPrefixo"
                        class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos"
                        :class="{ 'p-invalid': validarComex && (notaFiscal.comExtVServMoeda == null || notaFiscal.comExtVServMoeda <= 0) }"></money>
                    </span>
                  </div>

                  <div class="col-md-6 mb-2">
                    <label for="comExtMovTempBens">Movimentação Temporária de Bens: *</label>
                    <span class="p-fluid">
                      <Dropdown id="comExtMovTempBens" name="comExtMovTempBens" v-model="selectedMovimentacaoTemporariaBens" :options="movimentacoesTemporariaBens"
                        optionLabel="name" placeholder="Selecione a movimentação temporária"
                        :disabled="desabilitarEdicaoCampos" :showClear="true"
                        :class="{ 'p-invalid': validarComex && (!selectedMovimentacaoTemporariaBens || !selectedMovimentacaoTemporariaBens.key) }" />
                    </span>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="comExtMecAfComexP">Mecanismo de Apoio / Fomento (Prestador): *</label>
                    <span class="p-fluid">
                      <Dropdown id="comExtMecAfComexP" name="comExtMecAfComexP" v-model="selectedMecanismoApoioPrestador" :options="mecanismosApoioPrestador"
                        optionLabel="name" placeholder="Selecione o mecanismo (Prestador)"
                        :disabled="desabilitarEdicaoCampos" :showClear="true"
                        :class="{ 'p-invalid': validarComex && (!selectedMecanismoApoioPrestador || !selectedMecanismoApoioPrestador.key) }" />
                    </span>
                  </div>

                  <div class="col-md-6 mb-2">
                    <label for="comExtMecAfComexT">Mecanismo de Apoio / Fomento (Tomador): *</label>
                    <span class="p-fluid">
                      <Dropdown id="comExtMecAfComexT" name="comExtMecAfComexT" v-model="selectedMecanismoApoioTomador" :options="mecanismosApoioTomador"
                        optionLabel="name" placeholder="Selecione o mecanismo (Tomador)"
                        :disabled="desabilitarEdicaoCampos" :showClear="true"
                        :class="{ 'p-invalid': validarComex && (!selectedMecanismoApoioTomador || !selectedMecanismoApoioTomador.key) }" />
                    </span>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="comExtMdic">Indicador de Envio MDIC: *</label>
                    <span class="p-fluid">
                      <Dropdown id="comExtMdic" name="comExtMdic" v-model="selectedIndicadorEnvioMdic" :options="indicadoresEnvioMdic"
                        optionLabel="name" placeholder="Selecione o indicador MDIC"
                        :disabled="desabilitarEdicaoCampos" :showClear="true"
                        :class="{ 'p-invalid': validarComex && (!selectedIndicadorEnvioMdic || !selectedIndicadorEnvioMdic.key) }" />
                    </span>
                  </div>
                </div>
              </Panel>
            </div>
          </div>
          <div class="row d-flex align-items-end">
            <div class="col-md-2 mb-2">
              <label for="valorServico">Valor Serviço: *</label>
              <span class="p-fluid">
                <money id="valorServico" name="valorServico" v-model="notaFiscal.valorServico" v-bind="money"
                  class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos" @blur.native="validarDescontoAutomatico()"></money>

                <!-- :class="{ 'is-invalid': loading && errors.has('descServico') }" -->
              </span>
            </div>
            <div class="col-md-2 mb-2">
              <label for="aliquota">Alíquota: *</label>
              <span class="p-fluid">
                <money id="aliquota" name="aliquota" v-model="notaFiscal.aliquota" v-bind="percent"
                  class="p-inputtext input-right" :disabled="desabilitarEdicaoAliquota"></money>
                <InlineMessage v-if="validation.hasError('notaFiscal.aliquota')">{{
                  validation.firstError("notaFiscal.aliquota")
                }}</InlineMessage>
              </span>
            </div>
            <div class="col-md-2 mb-2">
              <label for="deducao">Dedução:</label>
              <span class="p-fluid">
                <money id="deducao" name="deducao" v-model="notaFiscal.valorDesconto" v-bind="money"
                  class="p-inputtext input-right" :disabled="desabilitarEdicaoDeducao"></money>
              </span>
            </div>
            <div class="col-md-2 mb-2" v-if="!this.notaAvulsa">
              <label for="descIncond">Desconto Incondicional:</label>
              <span class="p-fluid">
                <money id="descIncond" name="descIncond" v-model="notaFiscal.valorDescontoIncond" v-bind="money"
                  class="p-inputtext input-right" :disabled="desabilitarEdicaoDescIncond"></money>
              </span>
            </div>
            <div class="col-md-2 mb-2" v-if="!this.notaAvulsa">
              <label for="descDiversos">Desconto Condicional:</label>
              <span class="p-fluid">
                <money id="descDiversos" name="descDiversos" v-model="notaFiscal.valorDescontosDiversos" v-bind="money"
                  class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos"></money>
              </span>
            </div>
          </div>
          <div class="row" >
            <div class="col-md-10 mb-2">
              <label for="descServico">Discriminação dos Serviços: *</label>
              <span class="p-fluid">
                <textarea id="descServico" name="descServico" v-model="notaFiscal.discriminacaoServico" rows="5"
                  :disabled="desabilitarEdicaoCampos" />
              </span>
            </div>
          </div>
          <div class="row" v-if="observacaoClienteNfse">
            <div class="col-md-10 mb-2">
              <label for="obs">Observação: </label>
              <span class="p-fluid">
                <textarea id="obs" name="obs" v-model="notaFiscal.observacao" rows="5"
                  :disabled="desabilitarEdicaoCampos" />
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2 mb-2" v-if="!isEmissaoPorDPS" >
              <label>Número RPS:</label>
              <span class="p-fluid">
                <InputText v-model="notaFiscal.rpsNumero" :disabled="desabilitarEdicaoCampos" type="number"></InputText>
              </span>
            </div>
            <div class="col-md-2 mb-2" v-if="exibirInfoDadosObra">
              <label>Número ART:</label>
              <span class="p-fluid">
                <InputText v-model="notaFiscal.numeroArt" type="text" :disabled="desabilitarDadosObra"></InputText>
              </span>
            </div>
            <div class="col-md-2 mb-2" v-if="exibirInfoDadosObra">
              <label>Número CEI:</label>
              <span class="p-fluid">
                <InputText v-model="notaFiscal.numeroCei" type="text" :disabled="desabilitarDadosObra"></InputText>
              </span>
            </div>
          </div>
          <div class="row" v-if="!this.notaAvulsa">
            <div class="col-md-2 mb-2">
              <label for="inss">Inss:</label>
              <span class="p-fluid">
                <money id="inss" name="inss" v-model="notaFiscal.valorInss" v-bind="money"
                  class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos"></money>
              </span>
            </div>
            <div class="col-md-2 mb-2">
              <label for="ir">Ir:</label>
              <span class="p-fluid">
                <money id="ir" name="ir" v-model="notaFiscal.valorIr" v-bind="money" class="p-inputtext input-right"
                  :disabled="desabilitarEdicaoCampos"></money>
              </span>
            </div>
            <div class="col-md-2 mb-2" v-if="!this.isEmissaoTesteValidacao && !isEmissaoPorDPS">
              <label for="csll">Csll:</label>
              <span class="p-fluid">
                <money id="csll" name="csll" v-model="notaFiscal.valorCsll" v-bind="money"
                  class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos"></money>
              </span>
            </div>
            <div class="col-md-2 mb-2">
              <label for="pis">Pis:</label>
              <span class="p-fluid">
                <money id="pis" name="pis" v-model="notaFiscal.valorPis" v-bind="money" class="p-inputtext input-right"
                  :disabled="desabilitarEdicaoCampos"></money>
              </span>
            </div>
            <div class="col-md-2 mb-2">
              <label for="cofins">Cofins:</label>
              <span class="p-fluid">
                <money id="cofins" name="cofins" v-model="notaFiscal.valorCofins" v-bind="money"
                  class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos"></money>
              </span>
            </div>
          </div>
          <div class="row" v-if="(isEmissaoTesteValidacao || isEmissaoPorDPS)">
            <div class="col-md-4 mb-2">
              <label for="tipoRetContrSocial">Tipo de Retenção Contribuições Sociais (PIS/COFINS/CSLL):</label>
              <span class="p-fluid">
                <Dropdown id="tipoRetContrSocial" name="tipoRetContrSocial" v-model="selectedTipoContrSociais" :options="tiposContrSociais"
                  optionLabel="name" placeholder="Selecione um Tipo de Retenção Contribuições Sociais" />
              </span>
            </div>
            <div class="col-md-2 mb-2">
              <label for="valorContribuicaoSocial">Contribuições Sociais - Retidas:</label>
              <span class="p-fluid">
                <money id="valorContribuicaoSocial" name="valorContribuicaoSocial" v-model="notaFiscal.valorContribuicaoSocial" v-bind="money"
                  class="p-inputtext input-right" :disabled="(selectedTipoContrSociais && selectedTipoContrSociais.key && selectedTipoContrSociais.key === '0') || desabilitarEdicaoCampos "></money>
              </span>
            </div>
          </div>
          <div class="row" v-if="!this.notaAvulsa && !isEmissaoPorDPS">
            <div class="col-md-2 mb-2">
              <label for="outrasRetencoes">Outras Retenções:</label>
              <span class="p-fluid">
                <money id="outrasRetencoes" name="outrasRetencoes" v-model="notaFiscal.outrasRetencoes" v-bind="money"
                  class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos"></money>
              </span>
            </div>
          </div>
          <div class="row" v-if="isEmissaoPorDPS">
            <div class="col-md-4 mb-2">
              <label for="tipoCompraGovernamental">A operação se trata de uma compra governamental?</label>
              <span class="p-fluid">
                <Dropdown id="tipoCompraGovernamental" name="tipoCompraGovernamental" v-model="selectedCompraGovernamental" :options="tipoCompraGovernamental"
                  optionLabel="name" placeholder="Selecione o tipo de operação" />
              </span>
            </div>
            <div class="col-md-4 mb-2" v-if="selectedCompraGovernamental && selectedCompraGovernamental.key === 'S'">
              <label for="tipoEnteGovernamental">Ente governamental*:</label>
              <span class="p-fluid">
                <Dropdown id="tipoEnteGovernamental" name="tipoEnteGovernamental" v-model="selectedEnteGovernamental" :options="tiposEnteGovernamental"
                  optionLabel="name" placeholder="Selecione o tipo ente governamental" />
              </span>
            </div>
          </div>
          <div class="row" v-if="exibirOperacaoGovernamental">
            <div class="col-md-4 mb-2" >
              <label for="tiposOpGovernamental">Operação governamental*:</label>
              <span class="p-fluid">
                <Dropdown id="tiposOpGovernamental" name="tiposOpGovernamental" v-model="selectedOperacaoGovernamental" :options="tiposOpGovernamental"
                  optionLabel="name" placeholder="Selecione o tipo operação governamental" />
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8 mb-2" v-if="exibirOperacaoGovernamental && selectedOperacaoGovernamental && selectedOperacaoGovernamental.key === '2'">
              <label for="chaveNfseNacional">NFS-e Nacional referenciadas.(Para a Operação "Recebimento do Pagamento", é obrigatorio informar ao menos uma chave NFS-e Nacional referenciada valida, informe abaixo.)</label>
              <div class="p-inputgroup">
                <InputText v-model="chaveNfseNacional" placeholder="Digite a Chave da NFS-e Nacional, depois clique em Adicionar" maxlength="50" />
                <Button title="Adicionar Chave NFS-e Nacional" icon="pi pi-plus" @click="adicionarChaveNFeNacional()" />
              </div>
            </div>
          </div>
          <div class="row" v-if="exibirOperacaoGovernamental && selectedOperacaoGovernamental && selectedOperacaoGovernamental.key === '2'">
            <div class="col-md-10 mb-2">
              <span class="p-fluid">
                <div class="flex align-items-center">
                  <Chip class="mt-2 mr-2 custom-chip" v-for="(str, index) in listaChaveNFse" :key="str" :label="str"
                    @remove="removerChaveNFse(index)" removable />
                </div>
              </span>
            </div>
          </div>
          <div class="row" v-if="this.notaAvulsa">
            <div class="col-md-2 mb-2">
              <label for="irrf">IRRF:</label>
              <span class="p-fluid">
                <money id="inirrfss" name="irrf" v-model="notaFiscal.valorIrrf" v-bind="money"
                  class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos || desabilitarEdicaoCamposImpostosFederais"></money>
              </span>
            </div>
            <div class="col-md-2 mb-2">
              <label for="inss">INSS:</label>
              <span class="p-fluid">
                <money id="inss" name="inss" v-model="notaFiscal.valorInss" v-bind="money"
                  class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos || desabilitarEdicaoCamposImpostosFederais"></money>
              </span>
            </div>
            <div class="col-md-2 mb-2">
              <label for="sest">SEST:</label>
              <span class="p-fluid">
                <money id="sest" name="sest" v-model="notaFiscal.valorSest" v-bind="money"
                  class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos || desabilitarEdicaoCamposImpostosFederais"></money>
              </span>
            </div>
            <div class="col-md-2 mb-2">
              <label for="senat">SENAT:</label>
              <span class="p-fluid">
                <money id="senat" name="senat" v-model="notaFiscal.valorSenat" v-bind="money"
                  class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos || desabilitarEdicaoCamposImpostosFederais"></money>
              </span>
            </div>
            <div class="col-md-2 mb-2 d-flex align-items-end">
              <Button
                @click="openDialogImpFederais()"
                label="Calcular Impostos Federais"
                type="button"
                class="p-button-primary mr-2"
                icon="pi pi-pencil"
                v-show="habilitarCalculoImpostosFederais"
                :disabled="desabilitarBotaoCalculoImpostosFederais"
              />
            </div>
          </div>
          <div class="row" v-if="false">
            <div class="col-md-10 mb-2">
              <Accordion @tab-open="false">
                <AccordionTab header="Houve diferimento (adiamento) do IBS CBS?" >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-2 mb-2">
                        <label for="percDiferimentoIbsEstadual">% Diferimento IBS Estadual:</label>
                        <span class="p-fluid">
                          <money id="percDiferimentoIbsEstadual" name="percDiferimentoIbsEstadual" v-model="notaFiscal.percDiferimentoIbsEstad" v-bind="percent"
                            class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos" >
                          </money>
                        </span>
                      </div>
                      <div class="col-md-2 mb-2">
                        <label for="percDiferimentoIbsMunicipal">% Diferimento IBS Municipal:</label>
                        <span class="p-fluid">
                          <money id="percDiferimentoIbsMunicipal" name="percDiferimentoIbsMunicipal" v-model="notaFiscal.percDiferimentoIbsMunic" v-bind="percent"
                            class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos" >
                          </money>
                        </span>
                      </div>
                      <div class="col-md-2 mb-2">
                        <label for="percDiferimentoCbs">% Diferimento CBS:</label>
                        <span class="p-fluid">
                          <money id="percDiferimentoCbs" name="percDiferimentoCbs" v-model="notaFiscal.percDiferimentoCbs" v-bind="percent"
                            class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos" >
                          </money>
                        </span>
                      </div>
                    </div>
                  </div>
                </AccordionTab>
              </Accordion>
            </div>
          </div>
          <div class="row" v-if="this.confImpFederais && this.confImpFederais.id && !this.notaAvulsa">
            <div class="col-md-10 mb-2">
              <Accordion @tab-open="aplicarImpFederais()">
                <AccordionTab header="Definir impostos federais por alíquota" >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-8 mb-2">
                        <Button label="Aplicar Alíquota Padrão" icon="pi pi-check" class="p-button-primary mr-2 p-button-success" @click="aplicarImpFederaisPadrao()"/>
                        <Button label="Limpar Alíquotas" icon="pi pi-times" class="p-button-primary" @click="limparImpFederaisPadrao()"/>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-2 mb-2">
                        <label for="tmpInss">% Inss:</label>
                        <span class="p-fluid">
                          <money id="tmpAliqInss" name="aliqInss" v-model="confImpFederais.aliquotaInss" v-bind="percent"
                            class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos" @change.native="aplicarImpFederais()">
                          </money>
                        </span>
                      </div>
                      <div class="col-md-2 mb-2">
                        <label for="tmpIr">% Ir:</label>
                        <span class="p-fluid">
                          <money id="tmpIir" name="ir" v-model="confImpFederais.aliquotaIr" v-bind="percent"
                            class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos" @change.native="aplicarImpFederais()"></money>
                        </span>
                      </div>
                      <div class="col-md-2 mb-2">
                        <label for="tmpCsll">% Csll:</label>
                        <span class="p-fluid">
                          <money id="tmpCsll" name="csll" v-model="confImpFederais.aliquotaCsll" v-bind="percent"
                            class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos" @change.native="aplicarImpFederais()"></money>
                        </span>
                      </div>
                      <div class="col-md-2 mb-2">
                        <label for="tmpPis">% Pis:</label>
                        <span class="p-fluid">
                          <money id="tmpPis" name="pis" v-model="confImpFederais.aliquotaPis" v-bind="percent"
                            class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos" @change.native="aplicarImpFederais()"></money>
                        </span>
                      </div>
                      <div class="col-md-2 mb-2">
                        <label for="tmpCofins">% Cofins:</label>
                        <span class="p-fluid">
                          <money id="tmpCofins" name="cofins" v-model="confImpFederais.aliquotaCofins" v-bind="percent"
                            class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos" @change.native="aplicarImpFederais()"></money>
                        </span>
                      </div>
                    </div>

                  </div>

                </AccordionTab>
              </Accordion>
            </div>
          </div>
          <div class="row d-flex align-items-end">
            <div class="col-md-2 mb-2">
              <label for="inss">Valor Total Serviço:</label>
              <span class="p-fluid">
                <money id="valorTotalServico" name="valorTotalServico" v-model="totalServico" v-bind="money"
                  class="p-inputtext input-right" disabled="true"></money>
              </span>
            </div>
            <div class="col-md-2 mb-2">
              <label for="valorIss">Valor ISSQN:</label>
              <span class="p-fluid">
                <money id="valorIss" name="valorIss" v-model="totalIss" v-bind="money" class="p-inputtext input-right"
                  disabled="true"></money>
              </span>
            </div>
          </div>
          <div class="botoes-avancar-voltar" style="margin-top: 10px;">

          <Button @click="adicionarNotaLote()" label="Adicionar Nota Fiscal ao Lote" type="button" class="p-button-primary mr-2 p-button-success"
            icon="pi pi-plus" v-show="exibirBotao.gravar && isEmissaoLote && !isBloqueado" :disabled="loading || inativo" />

          <Button @click="exibirLoteNotas()" label="Exibir/Gravar Lote" type="button" class="p-button-primary mr-2 p-button-success"
            icon="pi pi-search" v-show="exibirBotao.gravar && isEmissaoLote && !isBloqueado" :disabled="loading || inativo || quantidadeNotasLote == 0" />

          <Button @click="salvar()" label="Gravar" type="button" class="p-button-primary mr-2 p-button-success"
            icon="pi pi-check" v-show="exibirBotao.gravar && !isEmissaoLote && !isBloqueado" :disabled="loading || inativo" />

          <Button @click="salvar(true)" label="Visualizar" type="button" class="p-button-primary mr-2"            
            icon="pi pi-print" v-show="exibirBotao.gravar && !isEmissaoPorDPS" :disabled="loading" />

          <Button @click="abrirVisualizacaoIbsCbs()" label="Visualizar" type="button" class="p-button-primary mr-2"
            icon="pi pi-print" v-show="exibirBotao.gravar && isEmissaoPorDPS" :disabled="loading" />

          <Button @click="dpsId = null;novaNotaFiscal();" :label="isEmissaoLote ? 'Novo Lote' : 'Novo'" type="button" class="p-button-primary mr-2" icon="pi pi-plus"
            v-show="exibirBotao.novo && !isBloqueado" :disabled="loading || inativo" />

          <Button @click="copiarNotaFiscal()" label="Copiar NFS-e" type="button" class="p-button-primary mr-2"
            icon="pi pi-copy" v-show="disableCopiaNota && !isEmissaoLote && !selectedDpsId && !isBloqueado" />

          <Button @click="cancelarNotaFiscal()" label="Cancelar" type="button"
            class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" v-show="exibirBotao.cancelar && !isEmissaoLote && !isBloqueado"
            :disabled="loading || inativo" />

          <Button @click="imprimirNotaFiscal()" label="Imprimir" type="button" class="p-button-primary mr-2"
            icon="pi pi-print" v-show="exibirBotao.imprimir && !isEmissaoTesteValidacao && !isEmissaoPorDPS" :disabled="loading" />

          <Button
            class="p-button-primary mr-2"
            :disabled="loading"
            v-show="exibirBotao.imprimir && (isEmissaoTesteValidacao || isEmissaoPorDPS)"
            @click="visualizarDanfse()"
          >
            <span class="pi pi-download mr-2"></span>DANFSE
          </Button>  

          <Button @click="enviarEmailNotaFiscal()" label="Enviar por E-mail" type="button" class="p-button-primary mr-2"
            icon="pi pi-envelope" v-show="exibirBotao.email && !isEmissaoTesteValidacao" :disabled="loading" />

          <Button @click="carregarVencimentoBoleto()" label="DAM Nota Fiscal" type="button"
            class="p-button-primary mr-2" icon="pi pi-print" v-show="
              notaAvulsa == true &&
              this.pagaIssNota === 'S' &&
              this.notaFiscal.id != null &&
              this.notaFiscal.situacao != 'Cancelada' &&
              this.notaFiscal.tipoRecolhimento === 'N' &&
              this.notaAvulsaAcumulada == false && !isEmissaoTesteValidacao
            " :disabled="loading || inativo" />
          <Button @click="reenviarEmail(true)" label="Reenviar E-mail" type="button" class="p-button-primary mr-2"
            icon="pi pi-print" v-show="reenviar" :disabled="loading" />
          </div> 
        </div>
      </div>
    </div>
    <Dialog
            class="test-box"
            header="Realizar emissão no modelo DPS com IBS/CBS?"
            :visible.sync="showDlgIbsCbs"
            :contentStyle="{ overflow: 'visible' }"
            :modal="true"
            :closable="true"
          >
          
          <Panel header="Não">
              A emissão da nota fiscal continuará utilizando o modelo atual, sem IBS/CBS.
          </Panel>
          <br />
          <Panel header="Sim">
              Será obrigatória a informação dos novos campos necessários para a emissão da nota fiscal com IBS/CBS:
              <ul>
                  <li>Tipo de Destinatário</li>
                  <li>Indicador da Operação</li>
                  <li>Classificação Tributária</li>
                  <li>Possibilidade de informar Impostos federais não retidos (quando aplicável)</li>
              </ul>
          </Panel>
          
          <hr/>
          <template>
            <Button label="Fechar" title="Fechar" @click="showDlgIbsCbs = false" class="p-button-primary  mr-2 p-button-danger"
              icon="pi pi-times" :disabled="loading">
            </Button>
          </template>
    </Dialog>
    <Dialog header="Aviso" :visible.sync="displayDevedorContumazConfirmacao" :style="{ width: '42vw' }"
      :contentStyle="{ overflow: 'visible' }" :modal="true">
      <h1 class="titulo-header">
        Aviso
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="displayDevedorContumazConfirmacao = false" />
      </h1><br />
          {{ this.avisoDevedorContumaz }} <br/><br/> 
      <div class="container">
        <div class="row">
          <div>
            <Button @click="salvar()" label="Confirmar" type="button" class="p-button-primary mr-2 p-button-success"
            icon="pi pi-check"  />

            <Button
              @click="displayDevedorContumazConfirmacao = false"
              type="button"
              label="Cancelar"
              class="p-button-primary mr-2 p-button-danger"
              icon="pi pi-times"
            />
          </div>
        </div>
      </div>      
    </Dialog>
    <Dialog header="Aviso" :visible.sync="displayDevedorContumaz" :style="{ width: '42vw' }"
      :contentStyle="{ overflow: 'visible' }" :modal="true">
      <h1 class="titulo-header">
        Aviso
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="displayDevedorContumaz = false" />
      </h1><br />
          {{ this.avisoDevedorContumaz }} <br/><br/> <span style="color:red">(Aguarde realizando Geração do DAM!)</span>
      
    </Dialog>
    <Dialog header="DAM Nota Fiscal" :visible.sync="displayVencBoleto" :style="{ width: '42vw' }"
      :contentStyle="{ overflow: 'visible' }" :modal="true">
      <div class="col-md-4 mb-8">
        <label for="dataVencBoleto">Data de Vencimento: *</label>
        <span class="p-fluid">
          <Calendar :key="keyVencBoleto" id="dataVencBoleto" name="dataVencBoleto" v-model="dataVencimento"
            :showIcon="true" dateFormat="dd/mm/yy" />
        </span>
      </div>
      <template #footer>
        <Button label="Gerar DAM" icon="pi pi-check" v-show="damGerado != 'S'" @click="gerarDamNotaAvulsa()"
          :disabled="loading" />
        <Button label="Imprimir DAM" icon="pi pi-print" v-show="damGerado == 'S'" @click="imprimirBoleto()"
          :disabled="loading" />
        <div v-if="damGerado == 'S' && habilitarPix">
          <Button type="button" label="Pagar com PIX" title="Pagar com PIX" class="p-button-outlined mr-2"
            icon="pi pix-icon" style="margin-right: 0.5em" :disabled="loading" @click="criarPagamentoPix()"
            v-show="damGerado == 'S' && habilitarPix"></Button>
          <Button label="Imprimir DAM PIX" class="p-button-outlined mr-2" icon="pi pix-icon" v-show="damGerado == 'S'"
            @click="imprimirBoletoPix()" :disabled="loading" />
          <Button title="Consultar Pagamento PIX" label="Consultar Pagamento PIX" icon="pi pi-search"
            style="margin-right: 0.5em" @click="consultarPagamentoPix()" v-show="damGerado == 'S' && habilitarPix" />
        </div>
        <Button label="Cancelar DAM" icon="pi pi-print" v-show="damGerado == 'S'" @click="cancelarDamNotaAvulsa()"
          :disabled="loading" class="p-button-danger" />
        <Button label="Fechar" icon="pi pi-times" @click="hideVencBoleto()" class="p-button-secondary" />
      </template>
    </Dialog>
    <Dialog :visible.sync="showPix" :style="{ width: '40vw' }" :modal="true">
      <template #header>
        <Button class="p-button-outlined mr-2" icon="pi pix-icon" />
        <h3>Pagar com PIX</h3>
      </template>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6 mb-2">
            <QRCanvas :options="optionsPix" />
          </div>
          <div class="col-md-6 mb-2">
            <div style="padding-top: 20px">
              Utilize o App de sua Instituição Financeira, na opção PIX escolha
              pagar com QR Code, confirme os dados e realize o Pagamento. <br />
              <br /><span style="font-weight: bold">Valor Total:
                {{ this.pixGerado ? this.pixGerado.valorFormatado : 0 }}</span>
            </div>
          </div>
        </div>
        <div class="row" v-if="this.pixGerado && this.pixGerado.qrCode" >
          <div class="col-md-12 mb-2">
            <Button label="Copiar Código PIX" icon="pi pi-copy" @click="copiarPix()"  />
          </div>
        </div>
      </div>

      <template #footer>
        <Button label="Fechar" icon="pi pi-times" @click="showPix = false" class="p-button-danger" />
      </template>
    </Dialog>

    <Dialog header="Notas Fiscais no Lote" :visible.sync="showLote" :modal="true" :closable="false">
      <div class="scrolable-dialog">
        <div class="row">
          <div style="width: 100%" class="error-list">
            <Message :closable="false" severity="error" v-if="exibeErroTabelaLote()">
              <span>Uma ou mais Notas Fiscais no Lote não foram salvas!</span>
            </Message>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12" v-if="this.selectedPessoa">
            <b>Tomador:</b>
            {{this.selectedPessoa.detail}}
          </div>
          <div class="col-md-12" v-if="this.selectedPessoaIntermediario">
            <b>Intermediário:</b>
            {{this.selectedPessoaIntermediario.detail}}
          </div>
        </div>
        <div class="row">
          <DataTable :value="loteNotas" :paginator="true" :rows="10" :autoLayout="true" :rowClass="classeErroTabelaLote">
            <Column field="detailServico" header="Serviço"></Column>
            <Column field="aliquotaFormatada" header="Alíquota"></Column>
            <Column field="valorFormatado" header="Valor Serviço"></Column>
            <Column field="valorIssFormatado" header="Valor ISS"></Column>
            <Column v-if="false" field="erros" header="Erros">
              <ul class="mt-3">
                <li :key="erro" v-for="erro in erros">{{ erro }}</li>
              </ul>
            </Column>
            <Column headerStyle="width: 4em" bodyStyle="text-align: center">
              <template #body="slotProps">
                <Button
                  type="button"
                  icon="pi pi-trash"
                  class="p-button-danger"
                  @click="removerNotaLote(slotProps.data.hashLote)"
                ></Button>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div>
            <Button @click="salvarLote()" label="Gravar Lote" type="button" class="p-button-primary mr-2 p-button-success"
            icon="pi pi-check" v-show="exibirBotao.gravar" :disabled="loading || inativo" />

            <Button
              @click="ocultarLoteNotas()"
              type="button"
              label="Fechar"
              class="p-button-primary mr-2 p-button-danger"
              icon="pi pi-times"
            />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Calcular Impostos Federais" :visible.sync="showDialogImpFederais" :modal="true" :closable="false">
      <h1 class="titulo-header">
        Calcular Impostos Federais
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showDialogImpFederais = false" />
      </h1><br />
      <div class="scrolable-dialog">
        <div class="row">
          <div class="col-md-3 mb-3">
            <label for="irrf">Quantidade Dependentes:</label>
            <span class="p-fluid">
              <InputText
                id="quantidadeDependentes" name="quantidadeDependentes" v-model="paramImpFederalDependentes"
                type="number" min="0" :disabled="desabilitarEdicaoCampos"
              />
            </span>
          </div>
          <div class="col-md-3 mb-3">
            <label for="irrf">Dedução Prévia INSS:</label>
            <span class="p-fluid">
              <money id="inirrfss" name="irrf" v-model="notaFiscal.valorDeducaoPreviaInss" v-bind="money"
                class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos"></money>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 mb-3">
            <label for="irrf">% Sobre IRRF:</label>
            <span class="p-fluid">
              <money id="inirrfss" name="irrf" v-model="paramImpFederalPercIRRF" v-bind="percent"
                class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos"></money>
            </span>
          </div>
          <div class="col-md-3 mb-3">
            <label for="irrf">% Sobre INSS:</label>
            <span class="p-fluid">
              <money id="inirrfss" name="irrf" v-model="paramImpFederalPercINSS" v-bind="percent"
                class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos"></money>
            </span>
          </div>
          <div class="col-md-3 mb-3">
            <label for="irrf">Alíquota SEST:</label>
            <span class="p-fluid">
              <money id="inirrfss" name="irrf" v-model="paramImpFederalAliqSEST" v-bind="percent"
                class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos"></money>
            </span>
          </div>
          <div class="col-md-3 mb-3">
            <label for="irrf">Alíquota SENAT:</label>
            <span class="p-fluid">
              <money id="inirrfss" name="irrf" v-model="paramImpFederalAliqSENAT" v-bind="percent"
                class="p-inputtext input-right" :disabled="desabilitarEdicaoCampos"></money>
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3 mb-3">
            <label for="irrf">Base Cálculo IRRF:</label>
            <span class="p-fluid">
              <money id="inirrfss" name="irrf" v-model="outImpFederalBaseIRRF" v-bind="money"
                class="p-inputtext input-right" :disabled="true"></money>
            </span>
          </div>
          <div class="col-md-3 mb-3">
            <label for="irrf">Alíquota IRRF:</label>
            <span class="p-fluid">
              <money id="inirrfss" name="irrf" v-model="outImpFederalAliqIRRF" v-bind="percent"
                class="p-inputtext input-right" :disabled="true"></money>
            </span>
          </div>
          <div class="col-md-3 mb-3">
            <label for="irrf">Base Cálculo INSS:</label>
            <span class="p-fluid">
              <money id="inirrfss" name="irrf" v-model="outImpFederalBaseINSS" v-bind="money"
                class="p-inputtext input-right" :disabled="true"></money>
            </span>
          </div>
          <div class="col-md-3 mb-3">
            <label for="irrf">Alíquota INSS:</label>
            <span class="p-fluid">
              <money id="inirrfss" name="irrf" v-model="outImpFederalAliqINSS" v-bind="percent"
                class="p-inputtext input-right" :disabled="true"></money>
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3 mb-3">
            <label for="irrf">IRRF:</label>
            <span class="p-fluid">
              <money id="inirrfss" name="irrf" v-model="notaFiscal.valorIrrf" v-bind="money"
                class="p-inputtext input-right" :disabled="true"></money>
            </span>
          </div>
          <div class="col-md-3 mb-3">
            <label for="inss">INSS:</label>
            <span class="p-fluid">
              <money id="inss" name="inss" v-model="notaFiscal.valorInss" v-bind="money"
                class="p-inputtext input-right" :disabled="true"></money>
            </span>
          </div>
          <div class="col-md-3 mb-3">
            <label for="sest">SEST:</label>
            <span class="p-fluid">
              <money id="sest" name="sest" v-model="notaFiscal.valorSest" v-bind="money"
                class="p-inputtext input-right" :disabled="true"></money>
            </span>
          </div>
          <div class="col-md-3 mb-3">
            <label for="senat">SENAT:</label>
            <span class="p-fluid">
              <money id="senat" name="senat" v-model="notaFiscal.valorSenat" v-bind="money"
                class="p-inputtext input-right" :disabled="true"></money>
            </span>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div>
            <Button @click="calcularImpostosFederais()" 
            type="button" 
            label="Calcular" 
            class="p-button-primary mr-2 p-button-success"
            icon="pi pi-check" 
            :disabled="loading" />

            <Button
              @click="closeDialogImpFederais()"
              type="button"
              label="Fechar"
              class="p-button-primary p-button-danger"
              icon="pi pi-times"
            />
          </div>
        </div>
      </div>
    </Dialog>

    <Dialog :visible.sync="salvandoETransmitindo" :modal="true" :closable="false" :style="{ width: '35vw' }">
      <div class="text-center p-4">
        <i class="pi pi-spin pi-spinner text-primary mb-3" style="font-size: 3rem"></i>
        <h5 class="mt-2 font-weight-bold" style="color: #2c3e50;">Salvando e Transmitindo</h5>
        <p class="text-muted mt-2">A Nota Fiscal está sendo salva e transmitida para o Nacional. Por favor, aguarde...</p>
      </div>
    </Dialog>

    <Dialog :visible.sync="carregandoDps" :modal="true" :closable="false" :style="{ width: '35vw' }">
      <div class="text-center p-4">
        <i class="pi pi-spin pi-spinner text-primary mb-3" style="font-size: 3rem"></i>
        <h5 class="mt-2 font-weight-bold" style="color: #2c3e50;">Carregando DPS</h5>
        <p class="text-muted mt-2">Aguarde, carregando dados da DPS...</p>
      </div>
    </Dialog>
    <VisualizacaoDpsIbsCbs
      :visivel.sync="visivelVisualizacaoIbsCbs"
      :notaFiscal="notaFiscal"
      :prestador="dadosPrestador"
      :tomador="notaFiscal.tomador"
      :servicoNacional="selectedServicoNacional"
      :simulacaoRequest="reqIbsCbs"
      :informacoesExtras="informacoesExtrasIbsCbs"
      @emitir="emitirNotaDps"
    />
  </div>
</template>
<script>
import money from "../conf/config.money";
import percent from "../conf/config.percent";
import NotaFiscal from "../models/nfse/NotaFiscal";
import LocalidadeService from "../services/acesso/localidade.service";
import LoginService from "../services/acesso/login.service";
import NotaFiscalService from "../services/nfse/notafiscal.service";
import NotaFiscalTesteService from "../services/nfse/notafiscalteste.service";
import NfsPessoaService from "../services/nfse/pessoa.service";
import ContribuinteAtividadeService from "../services/tributario/contribuinte.atividade.service";
import ContribuinteServicoService from "../services/tributario/contribuinte.servico.service";
import ServicoNacionalService from "../services/tributario/servico.nacional.service";
// import SimpleVueValidation from "simple-vue-validator";
import { QRCanvas } from "qrcanvas-vue";
import VisualizacaoDpsIbsCbs from "../components/emissaoNfse/VisualizacaoDpsIbsCbs";
import CancelarNotaFiscal from "../components/emissaoNfse/CancelarNotaFiscal";
import CopiarNotaFiscal from "../components/emissaoNfse/CopiarNotaFiscal";
import DetalhesContribuinte from "../components/emissaoNfse/DetalhesContribuinte";
import EnviarEmailNotaFiscal from "../components/emissaoNfse/EnviarEmailNotaFiscal";
import RemoverDestinatario from "../components/emissaoNfse/RemoverDestinatario";
import RemoverIntermediario from "../components/emissaoNfse/RemoverIntermediario";
import RemoverTomador from "../components/emissaoNfse/RemoverTomador";
import PaisService from "../services/acesso/pais.service";
import NotaFiscalAvulsaService from "../services/nfse/notafiscalavulsa.service";
import NotaFiscalNacionalService from "../services/nfse/notafiscalnacional.service";
import ObrasService from "../services/obras/obras.service";
import ImovelService from "../services/nfse/imovel.service";
import ReportService from "../services/report.service";
import ObrasCadastroDialog from "../views/ObrasCadastroDialog";
import ImovelCadastroDialog from "../views/ImovelCadastroDialog";
import TomadorCadastro from "../views/TomadorCadastro";

// const Validator = SimpleVueValidation.Validator;

export default {
  name: "EmissaoNfse",
  props: {
    testeValidacao: Boolean
  },
  components: {
    TomadorCadastro,
    RemoverTomador,
    RemoverIntermediario,
    RemoverDestinatario,
    CopiarNotaFiscal,
    CancelarNotaFiscal,
    DetalhesContribuinte,
    EnviarEmailNotaFiscal,
    QRCanvas,
    VisualizacaoDpsIbsCbs,
    ObrasCadastroDialog,
    ImovelCadastroDialog
  },

  data() {
    return {
      reenviar: false,
      money: money,
      moneySemPrefixo: {
        ...money,
        prefix: ""
      },
      dados: null,
      inativo: false,
      percent: percent,
      loading: false,
      emissaoPorAtividade: false,
      erros: [],
      errosDps: [],
      currentUser: null,
      dadosTela: null,
      notaFiscal: new NotaFiscal(),
      dadosNotaSubstituida: null,
      filteredPessoas: null,
      filteredLocalidades: null,
      filteredAtividade: null,
      filteredServicos: null,
      filteredServicosNacionais: null,
      filteredNbs: null,
      filteredIndop: null,
      filteredClasstrib: null,
      filteredObras: null,
      filteredImoveis: null,
      tiposTomador: [
        { name: "CPF/CNPJ/Nome", key: "C" },
        //{ name: "Exterior", key: "E" },
      ],
      tiposExportacao: [
        {name: "Não", key: "N"},
        {name: "Sim", key: "S"}
      ],
      tiposIntermediario: [
        {name: "Não", key: "N"},
        {name: "Sim", key: "S"}
      ],
      tiposDestinatario: [
        {name: "Sim", key: "S"},
        {name: "Não", key: "N"}
      ],
      tipoCompraGovernamental: [
        {name: "Não", key: "N"},
        {name: "Sim", key: "S"}
        
      ],
      tiposEnteGovernamental: [
        {name: "União", key: "1"},
        {name: "Estado", key: "2"},
        {name: "Distrito Federal", key: "3"},
        {name: "Município", key: "4"}
        
      ],
      tiposOpGovernamental: [
        {name: "Fornecimento", key: "1"},
        {name: "Recebimento do Pagamento", key: "2"}
        
      ],
      locaisPrestacao: [
        { name: "Município", key: "M" },
        { name: "Fora do Município", key: "F" },
      ],
      tiposRecolhimento: [
        { name: "Não Retido", key: "N" },
        { name: "Retido na Fonte", key: "R" },
        { name: "Sem Recolhimento", key: "S" },
      ],
      tiposContrSociais: [
        { name: "PIS/COFINS/CSLL Não Retidos", key: "0" }, 
        { name: "PIS/COFINS/CSLL Retidos", key: "3" }, 
        { name: "PIS/COFINS Retidos, CSLL Não Retido", key: "4" }, 
        { name: "PIS Retido, COFINS/CSLL Não Retido", key: "5" }, 
        { name: "COFINS Retido, PIS/CSLL Não Retido", key: "6" }, 
        { name: "PIS Não Retido, COFINS/CSLL Retidos", key: "7" }, 
        { name: "PIS/COFINS Não Retidos, CSLL Retido", key: "8" }, 
        { name: "COFINS Não Retido, PIS/CSLL Retidos", key: "9" }
      ],
      selectedDpsId: null,
      selectedTipoContrSociais: null,
      selectedCompraGovernamental: null,
      selectedOperacaoGovernamental: null,
      selectedEnteGovernamental: null,
      selectedExportacao: null,
      selectedMunicOrigem: null,
      selectedMunicPrestacao: null,
      municipioIncidencia: "",
      selectedPessoa: null,
      selectedPessoaIntermediario: null,
      selectedPessoaDestinatario: null,
      selectedAtividade: null,
      selectedServico: null,
      selectedServicoNacional: null,
      selectedNbs: null,
      selectedIndop: null,
      selectedClasstrib: null,
      selectedObra: null,
      selectedImovel: null,
      selectedTipoTomador: null,
      selectedTipoIntermediario: "S",
      selectedTipoDestinatario: "S",
      selectedLocalPrestacao: null,
      selectedTipoRecolhimento: null,
      modosPrestacao: [],
      vinculosPrestacao: [],
      mecanismosApoioPrestador: [],
      mecanismosApoioTomador: [],
      movimentacoesTemporariaBens: [],
      indicadoresEnvioMdic: [],
      selectedModoPrestacao: null,
      selectedVinculoPrestacao: null,
      selectedMecanismoApoioPrestador: null,
      selectedMecanismoApoioTomador: null,
      selectedMovimentacaoTemporariaBens: null,
      selectedIndicadorEnvioMdic: null,
      validarComex: false,
      valorTotalServico: null,
      valorTotalIss: null,
      exibirDadosObra: null,
      notaAvulsa: null,
      damGerado: null,
      displayVencBoleto: false,
      keyVencBoleto: 1,
      dataVencimento: null,
      habilitarPix: false,
      showPix: false,
      optionsPix: {
        cellSize: 5,
        data: "hello",
      },
      pixGerado: null,
      opcaoServicoAberto: false,
      checkServicoAberto: false,
      observacaoClienteNfse: false,
      habilitarSelecaoObra: false,
      showImpFederaisAliquota: true,
      confImpFederais: null,
      exibirCalcImpFederais: false,
      habilitarCalculoImpostosFederais: false,
      showDialogImpFederais: false,
      paramImpFederalDependentes: 0,
      paramImpFederalPercIRRF : 0,
      paramImpFederalPercINSS: 0,
      paramImpFederalAliqSEST: 0,
      paramImpFederalAliqSENAT: 0,
      outImpFederalBaseIRRF: 0,
      outImpFederalAliqIRRF: 0,
      outImpFederalBaseINSS: 0,
      outImpFederalAliqINSS: 0,
      configTomador: null,
      travarEdicaoTomador: false,
      notaAvulsaAcumulada: false,
      displayDevedorContumaz: false,
      displayDevedorContumazConfirmacao: false,
      avisoDevedorContumaz: "CONTRIBUINTE ENQUADRADO EM REGIME ESPECIAL DE DEVEDOR CONTUMAZ. PARA CONCLUIR A EMISSÃO DA NOTA, REALIZE O RECOLHIMENTO DO ISS.",
      tiposTributacao:[
        { name: "Não", key: "ForaDaSede" },
        { name: "Sim", key: "Sede" },
      ],
      servicoTributadoFora: false,
      selectedTipoTributacao: null,
      pagaIssNota:'S',
      disableCopiaNota: true,
      loteNotas: [],
      showLote: false,
      tipoCadastroInvalido: false,
      codigoIbgePrincipal: null,
      idCliente: null,
      msgAvisoRegimeTribuNfse: null,
      isEmissaoPorServicoNacional:false,
      selectedPais: null,
      filteredPaises: null,
      codigoIbgeVal: null,
      salvandoETransmitindo: false,
      chaveAcesso: null,
      carregandoDps: false,
      tiposEmissaoDps:[
        { name: "Não", key: "N" },
        { name: "Sim", key: "S" },
      ],
      selectedTipoEmissaoDps: null,
      showDlgIbsCbs: false,
      tooltipText: "Ver Informações",
      visivelVisualizacaoIbsCbs: false,
      // informacoesExtrasIbsCbs: {},
      reqIbsCbs: null,
      listaChaveNFse: [],
      chaveNfseNacional: null,
      };  
  },

  watch: {
    $route(to, from) {
      //Força reload quando alterna entre as páginas de emissão, pois as duas rotas usam o mesmo componente.
      if ((to.path == '/emissaoNfse' && from.path == '/emissaoNfseLote') || (to.path == '/emissaoNfseLote' && from.path == '/emissaoNfse')) {
        window.location.reload();
      }else if ((to.path == '/emissaoNfse' && from.path == '/emissaoNfseTeste') || (to.path == '/emissaoNfseTeste' && from.path == '/emissaoNfse')) {
        this.novaNotaFiscal();
      }
      
    },selectedTipoContrSociais(novoValor) {
        if (novoValor && novoValor.key === '0' && this.notaFiscal && this.notaFiscal.valorSenat) {
          this.notaFiscal.valorSenat = '0';
        }
      }
  },

  mounted() {
    document.getElementById("tomador").focus();
  },

  created() {
    //console.log(this.tiposTomador);

    if (this.$route.query.reenviar && this.$route.query.reenviar == "S") {
      this.reenviar = true;
    }
    this.selectedPais = null;
    if(this.isEmissaoSoPorDPS){
      this.selectedTipoEmissaoDps = this.tiposEmissaoDps[1];
    }else{
      this.selectedTipoEmissaoDps = this.tiposEmissaoDps[0];
    }
    
    this.selectedTipoIntermediario = this.tiposIntermediario[0];
    this.selectedTipoDestinatario = this.tiposDestinatario[0];
    this.currentUser = LoginService.currentUserValue;
    this.idCliente = this.currentUser.usuario.idCliente;
    this.selectedTipoTributacao = this.tiposTributacao[0];
    this.habilitarPix = this.currentUser.configuracao.idBolUtilizarPix === "S";
    this.habilitarCalculoImpostosFederais = this.currentUser.configuracao.idBolCalculoImpostosFederais === "S";
    this.isEmissaoPorServicoNacional = this.currentUser.configuracao.idBolEmissaoPorServicoNacional === 'S';
    this.opcaoServicoAberto =
      this.currentUser.configuracao.idBolServicoAbertoNfse === "S";
    this.observacaoClienteNfse =
      this.currentUser.configuracao.idBolObservacaoNfse === "S";
    this.inativo =
      this.currentUser && this.currentUser.contribuinte
        ? !this.currentUser.contribuinte.ativo
        : false;
    this.tipoCadastroInvalido = false;    
    this.limparDadosNotaFiscal();
    if(!this.notaAvulsa && (this.currentUser.contribuinte && this.currentUser.configuracao && this.currentUser.contribuinte.idContribuinteTipo && this.currentUser.configuracao.idContrTipoEconomico && this.currentUser.contribuinte.idContribuinteTipo != this.currentUser.configuracao.idContrTipoEconomico)){
      this.tipoCadastroInvalido = true;
      this.inativo = true;
    }
    
    this.codigoIbgePrincipal = this.currentUser.configuracao.codigoIbgeCliente;

    //correcao realizada pois a emissao de nota avulsa não deve dependender da seleção da atividade
    this.emissaoPorAtividade = (this.notaAvulsa ? false : this.currentUser.configuracao.idBolHabilitaCnaeNf && this.currentUser.configuracao.idBolHabilitaCnaeNf === 'S');
    
    this.confImpFederais = JSON.parse(JSON.stringify(this.currentUser.confImpFederais));
    this.exibirCalcImpFederais = (this.confImpFederais && this.confImpFederais.id);
    
    if (this.currentUser.configuracao.idBolTomadorNaoInformado == "S" && this.currentUser.contribuinteConfig.idBolTomadorNaoInformado != 'N'){
      this.tiposTomador.push({ name: "Não Identificado", key: "N" });
    } else if(this.currentUser.contribuinteConfig.idBolTomadorNaoInformado === 'S'){
      this.tiposTomador.push({ name: "Não Identificado", key: "N" });
    }

    if (this.currentUser.contribuinteConfig.idBolTomadorExterior === 'S'){
      this.tiposTomador.push({ name: "Exterior", key: "E" });
    }

    //Configuração Tomador
    this.configTomador = this.currentUser.configuracao.idBolSelTomadorDiferente;

    this.msgAvisoRegimeTribuNfse = this.currentUser.configuracao.msgAvisoRegimeTribuNfse;
  

    this.exibirDadosObra = this.currentUser.configuracao.idBolDadosObra;
    this.travarEdicaoTomador = false;
    this.carregarCombosComercioExterior();

    // this.disableCopiaNota = true;
    this.dpsId = this.$route.params.dpsId;

    if (this.dpsId != null) {
      this.processando(true);
      this.carregandoDps = true;
      const dados = {
        dpsId: this.dpsId,
        isEmissaoTesteValidacao: this.isEmissaoTesteValidacao
      };
      setTimeout(() => {
        this.$root.$emit("notaFiscal:copiar", dados);
      }, 150);
      this.selectedTipoEmissaoDps = this.tiposEmissaoDps[1];
    }else if (this.$route.params.dadosSubstituicao) {
      
      this.dadosNotaSubstituida = this.$route.params.dadosSubstituicao;
      this.disableCopiaNota = this.dadosNotaSubstituida.copiaNota;
      //console.log(this.disableCopiaNota+" Disable copia nota");
      this.notaFiscal.idNotaSubstituida = this.dadosNotaSubstituida.id;
      
      this.processando(true);
      const servicoAtivo = this.isEmissaoTesteValidacao ? NotaFiscalTesteService : NotaFiscalService; 
      servicoAtivo.findByNotaSubstituicao(this.dadosNotaSubstituida.id)
          .then(data => {
            const nota = data.data;

            if(this.currentUser.usuario.idCliente === "19533831040781681800D2584C905F8A" || this.configTomador === "S"){
              //simoes filho não permite editar o tomador na substituicao
              this.travarEdicaoTomador = true;
            }

            if (nota) {
              if (nota.tomadorDados) {
                if (nota.tomadorDados.tipo != "N") {
                  this.selectedPessoa = nota.tomadorDados;
                  
                  if (nota.intermediarioDados && this.currentUser.configuracao.idBolIntermediario && this.currentUser.configuracao.idBolIntermediario == "S") {
                    this.selectedTipoIntermediario = this.tiposIntermediario.filter(
                      tipo => tipo.key == "S"
                    )[0];
                    this.selectedPessoaIntermediario = nota.intermediarioDados;
                  } else {
                    this.selectedTipoIntermediario = this.tiposIntermediario.filter(
                      tipo => tipo.key == "N"
                    )[0];
                  }
                } else {
                  this.selectedTipoTomador = this.tiposTomador.filter(
                    tipo => tipo.key == nota.tomadorDados.tipo
                  )[0];
                }
              }
              if(nota.emissaoPorDps){
                this.selectedTipoEmissaoDps = this.tiposEmissaoDps[1];
              }else{
                this.selectedTipoEmissaoDps = this.tiposEmissaoDps[0];
              }
              if (nota.tipoContribuicaoSocial && nota.tipoContribuicaoSocial != null && nota.tipoContribuicaoSocial != undefined) {
                this.selectedTipoContrSociais = this.tiposContrSociais.filter(
                  local => local.key == nota.tipoContribuicaoSocial
                )[0];
              } else {
                this.selectedTipoContrSociais = this.tiposContrSociais[0];  
              }
              this.selectedEnteGovernamental = null; 
              this.selectedCompraGovernamental = null;
              if (nota.tipoEnteGovernamental && nota.tipoEnteGovernamental != null && nota.tipoEnteGovernamental != undefined) {
                this.selectedCompraGovernamental = this.tipoCompraGovernamental[1];
                this.selectedEnteGovernamental = this.tiposEnteGovernamental.filter(
                  local => local.key == nota.tipoEnteGovernamental
                )[0];
              }
              this.selectedOperacaoGovernamental = null; 
              if (nota.tipoOperacaoGovernamental && nota.tipoOperacaoGovernamental != null && nota.tipoOperacaoGovernamental != undefined) {
                this.selectedOperacaoGovernamental = this.tiposOpGovernamental.filter(
                  local => local.key == nota.tipoOperacaoGovernamental
                )[0];
              }

              if (nota.refNfseNacional) {
                this.listaChaveNFse = nota.refNfseNacional.split(',').map(ref => ref.trim());
              }

              this.selectedAtividade = null;
              if(nota.contribuinteAtividade && nota.contribuinteAtividade.id){
                this.selectedAtividade = nota.contribuinteAtividade;  
              }
              this.selectedServico = nota.contribuinteServico;

              this.selectedLocalPrestacao = this.locaisPrestacao.filter(
                local => local.key == nota.localPrestacao
              )[0];

              const valorOuZero = valor => valor != null ? valor : 0;

              this.notaFiscal.valorServico = valorOuZero(nota.valorServico);
              this.notaFiscal.aliquota = valorOuZero(nota.valorAliquota);
              this.notaFiscal.valorDesconto = valorOuZero(nota.valorDesconto);
              this.notaFiscal.valorDescontoIncond = valorOuZero(nota.valorDescontoIncond);
              this.notaFiscal.valorDescontoCond = valorOuZero(nota.valorDescontoCond);
              this.notaFiscal.valorDescontosDiversos = valorOuZero(nota.valorDescontosDiversos);
              this.notaFiscal.discriminacaoServico = nota.discriminacaoServico;
              this.notaFiscal.observacao = nota.observacao;
              this.notaFiscal.valorInss = valorOuZero(nota.valorInss);
              this.notaFiscal.valorIr = valorOuZero(nota.valorIr);
              this.notaFiscal.valorCsll = valorOuZero(nota.valorCsll);
              this.notaFiscal.valorPis = valorOuZero(nota.valorPis);
              this.notaFiscal.valorCofins = valorOuZero(nota.valorCofins);
              this.notaFiscal.outrasRetencoes = valorOuZero(nota.outrasRetencoes);
              this.notaFiscal.valorContribuicaoSocial = valorOuZero(nota.valorContribuicaoSocial);

              this.notaFiscal.valorIrrf = valorOuZero(nota.valorIrrf);
              this.notaFiscal.valorSest = valorOuZero(nota.valorSest);
              this.notaFiscal.valorSenat = valorOuZero(nota.valorSenat);
              this.notaFiscal.numeroArt = nota.numeroArt;
              this.notaFiscal.numeroCei = nota.numeroCei;

              if(nota.obra && nota.obra.id){
                this.selectedObra = nota.obra;
              }else if (nota.imovel && nota.imovel.id) {//só é possível informar imovel caso não tenha obra
                this.selectedImovel = nota.imovel;
              }
              if(nota.servicoNacional && nota.servicoNacional.id){
                this.selectedServicoNacional = nota.servicoNacional;
              }
              if(nota.servicoNbs && nota.servicoNbs.id){
                this.selectedNbs = nota.servicoNbs;
              }
              if(nota.servicoIndop && nota.servicoIndop.id){
                this.selectedIndop = nota.servicoIndop;
              }
              if(nota.servicoClassTrib && nota.servicoClassTrib.id){
                this.selectedClasstrib = nota.servicoClassTrib;
              }

              if(nota.comExtMdPrestacao && this.modosPrestacao){
                this.selectedModoPrestacao = this.modosPrestacao.find(item => item.key == nota.comExtMdPrestacao) || null;
              }
              if(nota.comExtVincPrest && this.vinculosPrestacao){
                this.selectedVinculoPrestacao = this.vinculosPrestacao.find(item => item.key == nota.comExtVincPrest) || null;
              }
              if(nota.comExtMecAfComexP && this.mecanismosApoioPrestador){
                this.selectedMecanismoApoioPrestador = this.mecanismosApoioPrestador.find(item => item.key == nota.comExtMecAfComexP) || null;
              }
              if(nota.comExtMecAfComexT && this.mecanismosApoioTomador){
                this.selectedMecanismoApoioTomador = this.mecanismosApoioTomador.find(item => item.key == nota.comExtMecAfComexT) || null;
              }
              if(nota.comExtMovTempBens && this.movimentacoesTemporariaBens){
                this.selectedMovimentacaoTemporariaBens = this.movimentacoesTemporariaBens.find(item => item.key == nota.comExtMovTempBens) || null;
              }
              if(nota.comExtMdic && this.indicadoresEnvioMdic){
                this.selectedIndicadorEnvioMdic = this.indicadoresEnvioMdic.find(item => item.key == nota.comExtMdic) || null;
              }
              this.notaFiscal.comExtTpMoeda = nota.comExtTpMoeda || '';
              this.notaFiscal.comExtVServMoeda = valorOuZero(nota.comExtVServMoeda);
              
              //carrega o munic de origem e de prestacao e atualiza os dados da pessoa
              const promises = [];
              const promiseLocalidade = this.searchLocalidadeCopiaNota(this.currentUser.configuracao.idCepLocalidadeCliente, nota.idMunicPrestacao);
              if (promiseLocalidade) {
                promises.push(promiseLocalidade);
              }

              if (nota.tomadorRemovido == "S") {
                this.$root.$emit(
                  "alert:warn:fixed",
                  "Os dados do Tomador não foram carregados, pois ele foi removido anteriormente!"
                );
              } else {
                const promisePessoa = this.atualizarDadosPessoaSelecionada(true);
                if (promisePessoa) {
                  promises.push(promisePessoa);
                }
              }
              const promiseDadosTela = this.atualizarDadosTela();
              if (promiseDadosTela) {
                promises.push(promiseDadosTela);
              }
              return Promise.all(promises);
            }
          })
          .catch(error => {
            console.error("Erro ao carregar dados de substituição:", error);
          })
          .then(() => {
            this.processando(false);
          });
    }

  },

  methods: {
    removerChaveNFse(index) {
      this.listaChaveNFse.splice(index, 1);
    },
    adicionarChaveNFeNacional() {
      const chave = this.chaveNfseNacional ? this.chaveNfseNacional.trim() : "";
      if (chave && chave.length === 50) {

        if (this.listaChaveNFse.includes(chave)) {
          this.$root.$emit(
            "alert:warn",
            "Esta chave NFS-e já foi adicionada!"
          );
          return;
        }

        this.listaChaveNFse.push(chave);
        this.chaveNfseNacional = null;

      } else {

        this.$root.$emit(
          "alert:warn",
          "Chave NFS-e deve ter o tamanho de 50 caracteres sem espaços!"
        );
      }
    },
    obterDadosDps(idCliente, dpsId){
      return NotaFiscalNacionalService.obterDadosDps(idCliente,dpsId)
        .then(response => {
          if (response.data) {
            if (response.data && response.data.chaveAcesso) {
              this.chaveAcesso = response.data.chaveAcesso;
              console.log(this.chaveAcesso);
              this.errosDps = [];
              return [];
            }
            if (response.data.erros && response.data.erros.length > 0) {
              this.errosDps = response.data.erros;
              this.chaveAcesso = null;
              return response.data.erros;
            }
            console.log(response.data);
            
          }
          return [];
        })
        .catch(err => {
          console.error("Erro ao obter dados da DPS:", err);
          return [];
        });
    },
    logTeste(to, from){
      console.log(to);
      console.log(from);
    },
    copiarPix(){
      navigator.clipboard.writeText(this.pixGerado.qrCode);
    },
    emissaoSelect(){
      let dateSelect = this.notaFiscal.dataFatoGerador;
      dateSelect.setHours(8);
      this.notaFiscal.dataFatoGerador = dateSelect;
      this.clearServico();
    },
    clearServico() {
      this.selectedAtividade = null;
      this.selectedServico = null;
      this.selectedServicoNacional = null;
      this.selectedNbs = null;
      this.selectedIndop = null;
      this.selectedClasstrib = null;
      this.notaFiscal.aliquota = 0;
    },
    searchPessoa(event) {
      setTimeout(async () => {
        this.filteredPessoas =
          await NfsPessoaService.findAllByConttribuinteFiltro(
            event.query,
            this.selectedTipoTomador.key
          );
      }, 250);
    },

    searchAtividade(event) {

      this.processando(true);

      setTimeout(async () => {
        this.filteredAtividade =
          await ContribuinteAtividadeService.findAllAtividadesByContribuinteFiltro(
            event.query,
            this.currentUser.contribuinte.idContribuinte
          )
        this.processando(false);
      }, 250);


    },

    searchAtividadeServicoVinc(event) {

      this.processando(true);

      setTimeout(async () => {
        this.filteredAtividade =
          await ContribuinteAtividadeService.findAllAtividadesByServicoVinc(
            event.query,
            this.currentUser.contribuinte.idContribuinte
          )
          console.log(this.filteredAtividade);
        this.processando(false);
      }, 250);


    },

    searchServico(event) {
      if (this.notaFiscal.dataFatoGerador) {
        this.processando(true);
        let dataEmissao = this.moment(this.notaFiscal.dataFatoGerador).format(
          "YYYY-MM-DD"
        );
        let filtro = event.query + "*;" + dataEmissao;
        if (!this.emissaoPorAtividade) {
          if (this.notaAvulsa || this.checkServicoAberto) {
            // Se for nota avulsa exibir todos os serviços
            setTimeout(async () => {
              this.filteredServicos =
                await ContribuinteServicoService.findAllNfAvulsa(
                  filtro,
                  this.currentUser.contribuinte.idContribuinte
                )
              this.processando(false);
            }, 250);
          } else {
            setTimeout(async () => {
              this.filteredServicos =
                await ContribuinteServicoService.findAllServicosByContribuinteFiltro(
                  filtro,
                  this.currentUser.contribuinte.idContribuinte
                )
              this.processando(false);
            }, 250);
          }
        } else {
          if(!this.selectedAtividade || !this.selectedAtividade.id){
            this.$root.$emit("alert:warn", "É necessário selecionar uma Atividade!");
          }
          if (this.selectedAtividade && this.selectedAtividade.id) {
            setTimeout(async () => {
              this.filteredServicos =
                await ContribuinteAtividadeService.findAllAtividadesByAtividadeFiltro(
                  filtro,
                  this.currentUser.contribuinte.idContribuinte,
                  this.selectedAtividade.id
                )
              this.processando(false);
            }, 250);
          } else {
            this.filteredServicos = [];
            this.processando(false);
          }
        }
      }
    },

    searchServicoNacional(event) {
      if (this.selectedServico && this.selectedServico.idServico && this.selectedServico.idServico.id) {
        this.processando(true);
        let filtro = event.query;
        setTimeout(async () => {
          this.filteredServicosNacionais =
            await ServicoNacionalService.findAllByServicoFiltro(
              this.selectedServico.idServico.id, filtro
            )
          this.processando(false);
        }, 250);
      }else{
        this.filteredServicosNacionais = [];
      }
    },

    searchServicoNacionalCompleto(event) {
        this.processando(true);
        let filtro = event.query;
        setTimeout(async () => {
          this.filteredServicosNacionais =
            await ServicoNacionalService.findAllByContribuinteFiltro(
              this.currentUser.usuario.idCliente, this.currentUser.contribuinte.idContribuinte,filtro,(this.notaAvulsa ? "S" : "N")
            )
          this.processando(false);
        }, 250);
    },

    searchNbs(event) {
      if (this.selectedServicoNacional && this.selectedServicoNacional.servicoNacional && this.selectedServicoNacional.servicoNacional.id) {
        this.processando(true);
        let filtro = event.query;
        setTimeout(async () => {
          this.filteredNbs =
            await ServicoNacionalService.findAllNBSByServicoNacionalFiltro(
              this.selectedServicoNacional.servicoNacional.id, filtro
            )
          this.processando(false);
        }, 250);
      }else{
        this.filteredNbs = [];
      }
    },

    searchIndop(event) {
        this.processando(true);
        let filtro = event != null ? event.query : '';
        setTimeout(async () => {
          this.filteredIndop =
            await ServicoNacionalService.findAllIndopByClienteFiltro(
              this.currentUser.usuario.idCliente, filtro
            )
          this.processando(false);
        }, 250);
    },

    searchClasstrib(event) {
        this.processando(true);
        let filtro = event != null ? event.query : '';
        setTimeout(async () => {
          this.filteredClasstrib =
            await ServicoNacionalService.findAllClasstribByClienteFiltro(
              this.currentUser.usuario.idCliente,filtro
            )
          this.processando(false);
        }, 250);
    },

    searchObra(event) {
      this.processando(true);
      setTimeout(async () => {
        this.filteredObras =
          await ObrasService.findAllByContirbuinte(
            event.query,
            this.currentUser.contribuinte.idContribuinte
          )
        this.processando(false);
      }, 250);
    },

    searchImovel(event) {
      this.processando(true);
      setTimeout(async () => {
        this.filteredImoveis =
          await ImovelService.findAllByContirbuinte(
            event.query,
            this.currentUser.contribuinte.idContribuinte
          )
        this.processando(false);
      }, 250);
    },

    searchPais(event) {
      setTimeout(async () => {
        this.filteredPaises = await PaisService.findAllByFiltro(event.query);
      }, 250);
    },

    searchLocalidade(event) {
      setTimeout(async () => {
        if(this.selectedLocalPrestacao && this.selectedLocalPrestacao.key === 'F'){
          this.filteredLocalidades = await LocalidadeService.findAllByFiltroSemIbge(
            event.query,
            this.codigoIbgePrincipal
          );
        }else{
          this.filteredLocalidades = await LocalidadeService.findAllByFiltroIbge(
            event.query
          );
        }
        console.log(this.filteredLocalidades);
      }, 250);
    },
    
    municPrestacaoSelecionado(){
      if (this.selectedMunicPrestacao && this.selectedMunicPrestacao.codigoIbge === 9999999 && this.currentUser.contribuinteConfig.idBolTomadorExterior != 'S') {
        this.selectedMunicPrestacao = this.selectedMunicOrigem;
        this.$root.$emit("alert:warn", "O prestador não pode selecionar local de prestação estrangeiro!");
        return;
      }
      if(this.selectedMunicOrigem && this.selectedMunicOrigem.id && this.selectedLocalPrestacao && this.selectedLocalPrestacao.key === 'F' && this.selectedTipoTributacao && this.selectedTipoTributacao.key === 'Sede'){
        this.municipioIncidencia = this.selectedMunicOrigem.detail;
        this.notaFiscal.idMunicIncidencia = this.selectedMunicOrigem.id;
      }else if(this.dadosTela && this.dadosTela.localIncidencia && this.dadosTela.localIncidencia === 'F' && this.selectedMunicPrestacao && this.selectedMunicPrestacao.id){
        this.municipioIncidencia = this.selectedMunicPrestacao.detail;
        this.notaFiscal.idMunicIncidencia = this.selectedMunicPrestacao.id;
      }else if(this.selectedMunicOrigem && this.selectedMunicOrigem.id){
        this.municipioIncidencia = this.selectedMunicOrigem.detail;
        this.notaFiscal.idMunicIncidencia = this.selectedMunicOrigem.id;
      }else{
        this.municipioIncidencia = "";
        this.notaFiscal.idMunicIncidencia = null;
      }
      this.codigoIbgeVal = (this.selectedMunicPrestacao && this.selectedMunicPrestacao.codigoIbge) ? this.selectedMunicPrestacao.codigoIbge : null;
    },

    searchLocalidadePorId(idMunic, entrada) {
      LocalidadeService.findAllById(idMunic).then((data) => {
        this.selectedMunicPrestacao = data.data;
        this.selectedMunicOrigem = data.data;//salva o de origem para reaproveitar futuramente
        if(entrada && this.selectedMunicOrigem && this.selectedMunicOrigem.id){
          this.municipioIncidencia = this.selectedMunicPrestacao.detail;
          this.notaFiscal.idMunicIncidencia = this.selectedMunicPrestacao.id;
        }
      });
    },
    searchLocalidadeCopiaNota(idMunicOrigem, idMunicPrestacao){
      if(idMunicOrigem){
        return LocalidadeService.findAllById(idMunicOrigem).then((data) => {
          this.selectedMunicOrigem = data.data;//salva o de origem para reaproveitar futuramente
          if(idMunicPrestacao){
            return LocalidadeService.findAllById(idMunicPrestacao).then((data) => {
              this.selectedMunicPrestacao = data.data;
            });
          }
        });
      }
      return Promise.resolve();
    },

    onSubmit() {
      this.$validate().then((success) => {
        if (success) {
          this.salvar();
        }
      });
    },

    setarDadosNotaFiscal() {
      this.notaFiscal.idSerie = this.currentUser.configuracao.idSeriePadrao;
      this.notaFiscal.idPrestadorDados =
        this.currentUser.contribuinte.idNfsPessoa;

      if (this.selectedTipoTomador.key !== "N") {
        if (this.selectedPessoa) {
          this.notaFiscal.idTomadorDados = this.selectedPessoa.id;
          this.notaFiscal.tomador = this.selectedPessoa;
        } else {
          this.notaFiscal.idTomadorDados = null;
          this.notaFiscal.tomador = null;
        }

        if (this.selectedPessoaIntermediario) {
          this.notaFiscal.idIntermediarioDados = this.selectedPessoaIntermediario.id;
        } else {
          this.notaFiscal.idIntermediarioDados = null;
        }
      }

      if (this.selectedTipoDestinatario && this.selectedTipoDestinatario.key) {
        this.notaFiscal.idBolDestinatarioTomador = this.selectedTipoDestinatario.key;

        if (this.selectedPessoaDestinatario && this.selectedPessoaDestinatario.id && this.selectedTipoDestinatario.key === 'N') {
          this.notaFiscal.idDestinatarioDados = this.selectedPessoaDestinatario.id;
        } else {
          this.notaFiscal.idDestinatarioDados = null;
        }

      } else {
        this.notaFiscal.idBolDestinatarioTomador = null;
      }

      if (this.selectedMunicPrestacao) {
        this.notaFiscal.idMunicPrestacao = this.selectedMunicPrestacao.id;
        this.notaFiscal.codigoMunicipio = this.selectedMunicPrestacao.codigoIbge;
      }

      console.log(this.selectedPais);
      if (this.selectedPais) {
        this.notaFiscal.idPaisPrestacao = this.selectedPais.id;
      }

      if (this.emissaoPorAtividade && this.selectedAtividade && this.selectedAtividade.id) {
        this.notaFiscal.idAtividade = this.selectedAtividade.id;
        this.notaFiscal.detailServico = this.selectedServico.detail;
        this.notaFiscal.codigoServico = this.selectedServico.idServico.codigoServico;
        this.notaFiscal.nomeServico = this.selectedServico.idServico.nomeServico;
      } else {
        this.notaFiscal.idAtividade = null;
        this.notaFiscal.detailServico = null;
        this.notaFiscal.codigoServico = null;
        this.notaFiscal.nomeServico = null;
      }

      if (this.selectedServico && this.selectedServico.idServico) {
        this.notaFiscal.idServicoItem = this.selectedServico.idServico.idServicoItem;
        this.notaFiscal.detailServico = this.selectedServico.detail;
        this.notaFiscal.codigoServico = this.selectedServico.idServico.codigoServico;
        this.notaFiscal.nomeServico = this.selectedServico.idServico.nomeServico;
      } else {
        this.notaFiscal.idServicoItem = null;
        this.notaFiscal.detailServico = null;
        this.notaFiscal.codigoServico = null;
        this.notaFiscal.nomeServico = null;
      }

      if (this.selectedServicoNacional && this.selectedServicoNacional.servicoNacional && this.selectedServicoNacional.servicoNacional.id) {
        this.notaFiscal.idServicoNacional = this.selectedServicoNacional.servicoNacional.id;
        this.notaFiscal.codigoServicoNacional = this.selectedServicoNacional.servicoNacional.codigoServico;
        this.notaFiscal.nomeServicoNacional = this.selectedServicoNacional.servicoNacional.nomeServico;
      } else {
        this.notaFiscal.idServicoNacional = null;
        this.notaFiscal.codigoServicoNacional = null;
        this.notaFiscal.nomeServicoNacional = null;
      }
      if (this.selectedNbs && this.selectedNbs.servicoNbs && this.selectedNbs.servicoNbs.id) {
        this.notaFiscal.idServicoNbs = this.selectedNbs.servicoNbs.id;
        this.notaFiscal.codigoNbs = this.selectedNbs.servicoNbs.codigoNbs;
      } else {
        this.notaFiscal.idServicoNbs = null;
        this.notaFiscal.codigoNbs = null;
      }
      if (this.selectedIndop && this.selectedIndop.id) {
        this.notaFiscal.idIndOperacao = this.selectedIndop.id;
        this.notaFiscal.codigoIndop = this.selectedIndop.codigoIndop;
      } else {
        this.notaFiscal.idIndOperacao = null;
        this.notaFiscal.codigoIndop = null;
      }
      if (this.selectedClasstrib && this.selectedClasstrib.id) {
        this.notaFiscal.idClassTrib = this.selectedClasstrib.id;
        this.notaFiscal.codigoClasstrib = this.selectedClasstrib.codigoClasstrib;
      } else {
        this.notaFiscal.idClassTrib = null;
        this.notaFiscal.codigoClasstrib = null;
      }

      if (this.selectedObra && this.selectedObra.id) {
        this.notaFiscal.idObra =
          this.selectedObra.id;
      } else {
        this.notaFiscal.idObra = null;
      }

      if (this.selectedImovel && this.selectedImovel.id) {
        this.notaFiscal.idImovel = this.selectedImovel.id;
      } else {
        this.notaFiscal.idImovel = null;
      }

      this.notaFiscal.selecaoExportacao = null;
      if(this.selectedExportacao && this.selectedExportacao.key){
        this.notaFiscal.selecaoExportacao = this.selectedExportacao.key;
      }

      this.notaFiscal.selecaoServicoTributadoFora = null;
      if(this.servicoTributadoFora && this.selectedTipoTributacao && this.selectedTipoTributacao.key){
        this.notaFiscal.selecaoServicoTributadoFora = this.selectedTipoTributacao.key;
      }

      this.notaFiscal.localPrestacao = this.selectedLocalPrestacao.key;
      this.notaFiscal.tipoRecolhimento = this.selectedTipoRecolhimento.key;
      this.notaFiscal.tipoContribuicaoSocial = this.selectedTipoContrSociais.key;
      this.notaFiscal.tipoEnteGovernamental = null;
      this.notaFiscal.tipoOperacaoGovernamental = null;
      this.notaFiscal.refNfseNacional = null;
      if(this.selectedCompraGovernamental && this.selectedCompraGovernamental.key === 'S'){
        this.notaFiscal.tipoEnteGovernamental = this.selectedEnteGovernamental.key;
      }
      if(this.exibirOperacaoGovernamental && this.selectedOperacaoGovernamental && this.selectedOperacaoGovernamental.key){
        this.notaFiscal.tipoOperacaoGovernamental = this.selectedOperacaoGovernamental.key;
        if(this.selectedOperacaoGovernamental.key === '2' && this.listaChaveNFse != null && this.listaChaveNFse.length > 0){
          this.notaFiscal.refNfseNacional = this.listaChaveNFse.join(',');
        }
      }

      if (this.exibirComercioExterior) {
        this.notaFiscal.comExtMdPrestacao = this.selectedModoPrestacao ? this.selectedModoPrestacao.key : null;
        this.notaFiscal.comExtVincPrest = this.selectedVinculoPrestacao ? this.selectedVinculoPrestacao.key : null;
        this.notaFiscal.comExtTpMoeda = this.notaFiscal.comExtTpMoeda ? this.notaFiscal.comExtTpMoeda : null;
        this.notaFiscal.comExtVServMoeda = this.notaFiscal.comExtVServMoeda ? this.notaFiscal.comExtVServMoeda : 0;
        this.notaFiscal.comExtMecAfComexP = this.selectedMecanismoApoioPrestador ? this.selectedMecanismoApoioPrestador.key : null;
        this.notaFiscal.comExtMecAfComexT = this.selectedMecanismoApoioTomador ? this.selectedMecanismoApoioTomador.key : null;
        this.notaFiscal.comExtMovTempBens = this.selectedMovimentacaoTemporariaBens ? this.selectedMovimentacaoTemporariaBens.key : null;
        this.notaFiscal.comExtMdic = this.selectedIndicadorEnvioMdic ? this.selectedIndicadorEnvioMdic.key : null;
      } else {
        this.notaFiscal.comExtMdPrestacao = null;
        this.notaFiscal.comExtVincPrest = null;
        this.notaFiscal.comExtTpMoeda = null;
        this.notaFiscal.comExtVServMoeda = 0;
        this.notaFiscal.comExtMecAfComexP = null;
        this.notaFiscal.comExtMecAfComexT = null;
        this.notaFiscal.comExtMovTempBens = null;
        this.notaFiscal.comExtMdic = null;
      }

      this.notaFiscal.servico = this.totalServico;
      if(this.selectedTipoRecolhimento && this.selectedTipoRecolhimento.key === "S"){
        this.notaFiscal.valorIss = 0;
      }else{
        this.notaFiscal.valorIss = this.totalIss;
      }
      this.notaFiscal.valorBaseCalculo = this.baseCalculo;
      this.notaFiscal.valorLiquido = this.valorLiquido;
      //console.log(this.notaFiscal.outrasRetencoes);

      //this.notaFiscal.dataEmissao = new Date(); // Quando a nota foi persistida no banco
      //this.notaFiscal.dataHoraEmissao = new Date(); // Quando a nota foi persistida no banco
      //this.notaFiscal.ano = this.notaFiscal.dataFatoGerador.getFullYear();
      //this.notaFiscal.mes = this.notaFiscal.dataFatoGerador.getMonth() + 1; // O getMonth busca valor de 0 a 11
    },

    async salvar(visualizar = false) {
      let isNacional = !visualizar && this.isHabilitarNotaNacional && (this.isEmissaoTesteValidacao || this.isEmissaoPorDPS);
      if (isNacional) {
        this.salvandoETransmitindo = true;
        this.loading = true;
      } else {
        this.processando(true);
      }
      let devedorCostumaz = this.currentUser && this.currentUser.contribuinte && this.currentUser.contribuinte.devedorCostumaz && this.currentUser.contribuinte.devedorCostumaz === 'S';
      if(!visualizar && devedorCostumaz && !this.displayDevedorContumazConfirmacao && this.currentUser.usuario.idCliente === "bf1a05b0-3c4f-49a5-a2a0-acdc7092948f"){//especifico para conquista
        this.displayDevedorContumazConfirmacao = true;
        this.processando(false);
        this.salvandoETransmitindo = false;
        return;
      }
      this.setarDadosNotaFiscal();

      this.erros = [];

      if (this.exibirComercioExterior) {
        const errosComex = [];
        if (!this.selectedModoPrestacao || !this.selectedModoPrestacao.key) {
          errosComex.push("Informe o Modo de Prestação do Comércio Exterior.");
        }
        if (!this.selectedVinculoPrestacao || !this.selectedVinculoPrestacao.key) {
          errosComex.push("Informe o Vínculo da Prestação do Comércio Exterior.");
        }
        if (!this.notaFiscal.comExtTpMoeda || !this.notaFiscal.comExtTpMoeda.trim()) {
          errosComex.push("Informe a Moeda do Comércio Exterior.");
        }
        if (this.notaFiscal.comExtVServMoeda == null || this.notaFiscal.comExtVServMoeda <= 0) {
          errosComex.push("Informe o Valor do Serviço na Moeda do Comércio Exterior.");
        }
        if (!this.selectedMovimentacaoTemporariaBens || !this.selectedMovimentacaoTemporariaBens.key) {
          errosComex.push("Informe a Movimentação Temporária de Bens do Comércio Exterior.");
        }
        if (!this.selectedMecanismoApoioPrestador || !this.selectedMecanismoApoioPrestador.key) {
          errosComex.push("Informe o Mecanismo de Apoio / Fomento (Prestador) do Comércio Exterior.");
        }
        if (!this.selectedMecanismoApoioTomador || !this.selectedMecanismoApoioTomador.key) {
          errosComex.push("Informe o Mecanismo de Apoio / Fomento (Tomador) do Comércio Exterior.");
        }
        if (!this.selectedIndicadorEnvioMdic || !this.selectedIndicadorEnvioMdic.key) {
          errosComex.push("Informe o Indicador de Envio MDIC do Comércio Exterior.");
        }

        if (errosComex.length > 0) {
          this.validarComex = true;
          this.erros = errosComex;
          this.processando(false);
          this.salvandoETransmitindo = false;
          this.loading = false;
          this.$root.$emit("alert:error", "Preencha todos os campos obrigatórios de Comércio Exterior!");
          return;
        }
      }
      this.validarComex = false;

      const servicoAtivo = this.isEmissaoTesteValidacao ? NotaFiscalTesteService : NotaFiscalService; 

      this.notaFiscal.visualizar = visualizar;
      this.notaFiscal.idBolEmissaoPorDps = this.isEmissaoPorDPS ? "S" : "N";
      if(this.selectedDpsId){
        this.notaFiscal.dpsId = this.selectedDpsId;
      }
      try {
        const data = await servicoAtivo.save(this.notaFiscal, this.selectedTipoTomador.key);
        this.displayDevedorContumazConfirmacao = false;
        if (this.notaFiscal.visualizar) {
          console.log(data);
        } else {
          this.notaFiscal = data.data;
          if(this.notaFiscal.dpsId){
            this.dpsId = this.notaFiscal.dpsId;
            this.selectedDpsId = this.notaFiscal.dpsId;
          }
          this.pagaIssNota = 'S';
          if(this.notaFiscal && this.notaFiscal.pagaIssNotaAtual && this.notaFiscal.pagaIssNotaAtual === 'N'){
            this.pagaIssNota = 'N';
          }
          this.notaAvulsaAcumulada = false;
          if(this.notaFiscal.acumularValorNfa && this.notaFiscal.acumularValorNfa === 'S'){
            this.notaAvulsaAcumulada = true;
          }

          devedorCostumaz = (this.notaFiscal.idBolDevedorContumaz && this.notaFiscal.idBolDevedorContumaz === 'S');

          if (isNacional && this.dpsId) {
            try {
              const dataTransmissao = await NotaFiscalNacionalService.transmitirDps(this.currentUser.usuario.idCliente, this.dpsId);
              console.log(dataTransmissao);
              this.errosDps = null;
              this.notaFiscal.id = "salvo"; // apenas para controle de não exibir botao

              const msgSuccess = this.notaAvulsa || devedorCostumaz ? "A Nota Fiscal foi salva! A transmissão será realizada após o pagamento do DAM." : "Transmissão realizada com sucesso!"
              this.$root.$emit("alert:success", msgSuccess);

              await this.obterDadosDps(this.currentUser.usuario.idCliente, this.dpsId);
              this.$nextTick(() => {
                const element = document.getElementById("dpsDadosId");
                if (element) {
                  element.focus();
                }
              });
            } catch (errorTransmissao) {
              if(errorTransmissao.response && errorTransmissao.response.data){
                this.$root.$emit("alert:warn", errorTransmissao.response.data);
              }else{
                this.$root.$emit("alert:warn", "Não foi possível transmitir a DPS, contate o município!");
              }
              const erros = await this.obterDadosDps(this.currentUser.usuario.idCliente,this.dpsId);
              if (erros && erros.length > 0) {
                this.$nextTick(() => {
                  const element = document.getElementById("dpsDadosId");
                  if (element) {
                    element.focus();
                  }
                });
              }
            }
          } else {
            this.$root.$emit("alert:success", "A Nota Fiscal foi salva!");
          }
          //Movido para o fim, pos independente de ser Nota Nacional ou não, 
          //se for devedor contumaz, deve gerar o DAM após salvar a Nota Fiscal.
          //Em Produção Restrita, não precisa gerar o DAM.
          if (devedorCostumaz && !this.isEmissaoTesteValidacao) {
            this.displayDevedorContumaz = true;
            this.dataVencimento = new Date();
            this.gerarDamNotaAvulsaAcao(true);
          }
        }
        this.disableCopiaNota = false;
      } catch (error) {
        let errorMessage = "Houve um problema ao salvar a Nota Fiscal!";
        if (error.response) {
          const errors = Array.isArray(error.response.data) 
            ? error.response.data 
            : [error.response.data];
            
          errors.forEach(err => {
            this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail: err,
              life: 5000
            });
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Erro",
            detail: errorMessage,
            life: 5000
          });
        }
      } finally {
        this.processando(false);
        this.salvandoETransmitindo = false;
      }
    },
    atualizarServico() {
      this.selectedServico = null;
    },
    atualizarValoresServico(limparServicoNacional){
      //console.log("atualiza valores Serviço");
      this.notaFiscal.valorDescontoIncond = 0;
      if(limparServicoNacional){
        this.selectedServicoNacional = null;
      }
      this.selectedNbs = null;
      this.selectedIndop = null;
      this.selectedClasstrib = null;
      this.atualizarDadosTela();
    },
    atualizarDadosServicoNacional(){
      this.processando(true);
      this.selectedObra = null;
      ContribuinteServicoService.getContribuinteServico(this.selectedServicoNacional.servico.id).then((contrServ) => {
        this.selectedServico = contrServ.data;
      }).then(() => {
        this.atualizarValoresServico(false);
      });
      
    },
    atualizarDadosTela() {
      let fatoGerador = null;
      let pagaIssqnSomenteMunicipio = null;

      if (!this.exibirOpcaoExportacao) {
        this.selectedExportacao = this.tiposExportacao[0];
      }

      if(this.notaFiscal && this.notaFiscal.dataFatoGerador){
        fatoGerador = this.notaFiscal.dataFatoGerador;
      }
      if(this.notaFiscal && this.notaFiscal.pagaIssqnSomenteMunicipio){
        pagaIssqnSomenteMunicipio = this.notaFiscal.pagaIssqnSomenteMunicipio;
      }
      if (
        this.selectedServico &&
        this.selectedServico.idServico &&
        this.selectedServico.idServico.idServicoItem
      ) {
        var idTomador = this.selectedPessoa ? this.selectedPessoa.id : "";
        let idServicoNacional = (this.selectedServicoNacional && this.selectedServicoNacional.servicoNacional && this.selectedServicoNacional.servicoNacional.id ? this.selectedServicoNacional.servicoNacional.id : null);
        this.processando(true);
        const servicoAtivo = this.isEmissaoTesteValidacao ? NotaFiscalTesteService : NotaFiscalService; 
        return servicoAtivo.validarDadosTelaNotaFiscalV3(
          this.selectedTipoTomador.key === 'E' && this.selectedExportacao.key === 'S' ? 'X' : this.selectedTipoTomador.key, //X = Exterior + Exportação
          this.selectedServico.idServico.idServicoItem,
          this.selectedServico.idBolSomenteRetencao,
          this.selectedLocalPrestacao.key,
          (this.selectedTipoRecolhimento ? this.selectedTipoRecolhimento.key : null),
          idTomador,
          this.notaAvulsa ? "S" : "N",
          fatoGerador,
          pagaIssqnSomenteMunicipio,
          idServicoNacional,
          this.codigoIbgeVal && this.codigoIbgeVal === 9999999 && this.selectedPais && this.selectedPais.id ? 'S' : this.selectedExportacao.key
        ).then((data) => {

          this.dadosTela = data.data;
          this.notaFiscal.idBeneficio = this.dadosTela.idBeneficio;
          this.servicoTributadoFora = this.dadosTela.servicoTributadoFora;
          this.selectedLocalPrestacao = this.locaisPrestacao.filter(
            (local) => local.key == this.dadosTela.localPrestacao
          )[0];

          if (this.selectedLocalPrestacao.key == "M") {
            this.selectedMunicPrestacao = this.selectedMunicOrigem;
          }else if(this.selectedMunicPrestacao && this.selectedMunicPrestacao == this.selectedMunicOrigem){
            this.selectedMunicPrestacao = null;
            this.municipioIncidencia = "";
            this.notaFiscal.idMunicIncidencia = null;
          }
          this.habilitarSelecaoObra = false;
          if (this.dadosTela.habilitarObra) {
            this.habilitarSelecaoObra = this.dadosTela.habilitarObra;
          }

          this.tiposRecolhimento = this.dadosTela.tiposRecolhimento;
          this.notaFiscal.aliquota = this.dadosTela.aliquota;
          this.notaFiscal.valorDesconto =
            this.dadosTela.deducao != null
              ? this.dadosTela.deducao
              : this.notaFiscal.valorDesconto;

          this.selectedTipoRecolhimento = this.dadosTela.tiposRecolhimento[0];
          this.validarDescontoAutomatico();
          this.municPrestacaoSelecionado();
        }).then(() => {
          this.processando(false);
        });
      }
      return Promise.resolve();
    },
    validarDescontoAutomatico(){
      if(this.dadosTela && (this.dadosTela.idBeneficio || (this.dadosTela.aplicarDeducaoAutomatica && this.dadosTela.aplicarDeducaoAutomatica === 'S'))  && this.dadosTela.percBeneficioBaseCalculo && this.dadosTela.percBeneficioBaseCalculo > 0
      && this.notaFiscal.valorServico && this.notaFiscal.valorServico > 0){
          let desconto = (this.notaFiscal.valorServico * this.dadosTela.percBeneficioBaseCalculo / 100.0)
          this.notaFiscal.valorDesconto = desconto;
      }
    },
    atualizarDadosObra() {
      this.notaFiscal.numeroArt = null;
      this.notaFiscal.numeroCei = null;
      if (this.selectedObra && this.selectedObra.id) {
        this.notaFiscal.numeroArt = this.selectedObra.numeroArt;
        this.notaFiscal.numeroCei = this.selectedObra.numeroCei;
      }
    },

    reenviarEmail() {
      NotaFiscalService.reenviarEmail(this.currentUser.usuario.idCliente).then(
        (data) => {
          console.log(data);
        }
      );
    },

    atualizarDadosPessoaSelecionada(evitarLoading = false) {
      
      if (
        this.selectedPessoa &&
        this.selectedPessoa.id
      ) {
        if (!evitarLoading) {
          this.processando(true);
        }
        const promise = NfsPessoaService.atualizaDadosPessoaValidacao(this.selectedPessoa.id).then(
          (data) => {
            console.log(data);
            this.selectedPessoa = data.data;
          },
          (error) => {
            if(error.response.data){
              this.$root.$emit("alert:warn", error.response.data);
            }else{
              this.$root.$emit("alert:warn", "Não foi possível selecionar o contribuinte!");
            }
            this.selectedPessoa = null;
          }
        );

        if (!evitarLoading) {
          return promise.then(() => {
            this.processando(false);
          });
        }
        return promise;
      }

      this.atualizarDadosTela();
      return Promise.resolve();
    },

  visualizarDanfse() {
      this.processando(true);

      const servicoAtivo = this.isEmissaoTesteValidacao ? NotaFiscalTesteService : NotaFiscalService;
      servicoAtivo.downloadDanfseHtmlByChaveNfse(this.currentUser.contribuinte.idContribuinte, this.chaveAcesso)
        .then((response) => {
          const html = response.data;
          ReportService.openHtmlFromBytes(html);
        })
        .catch((error) => {
          this.$root.$emit('alert:warn', 'Erro ao efetuar o download da DANFSE!');
          console.error('Erro ao efetuar o download da DANFSE:', error);
        })
        .then(() => {
          this.processando(false);
        });
    },

    imprimirNotaFiscal() {
      this.processando(true);

      let nomeRel = this.isEmissaoTesteValidacao ? "NotaFiscalEletronicaTeste" : (this.observacaoClienteNfse
        ? "NotaFiscalEletronicaObs"
        : "NotaFiscalEletronica");
        
      ReportService.imprimir(nomeRel, [
        {
          param: "where",
          string: " and nota_fiscal.id = '" + this.notaFiscal.id + "' ",
        }
      ])
        .then(
          (data) => {
            console.log(data);
          },
          (error) => {
            this.$root.$emit("alert:warn", "Erro ao exibir a visualização!");
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },

    visualizarNotaFiscal() {
      this.processando(true);

      let nomeRel = this.isEmissaoTesteValidacao ? "NotaFiscalEletronicaTeste" : (this.observacaoClienteNfse
        ? "NotaFiscalEletronicaObs"
        : "NotaFiscalEletronica");

      ReportService.visualizar(
        nomeRel,
        [
          {
            param: "where",
            string: " and nota_fiscal.id = '" + this.notaFiscal.id + "' ",
          }
        ],
        this.notaFiscal.id
      )
        .then(
          (data) => {
            console.log(data);
          },
          (error) => {
            this.$root.$emit("alert:warn", "Erro ao exibir a visualização!");
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },

    novaNotaFiscal(limparLote = true) {
      this.disableCopiaNota = true;
      this.erros = [];
      this.errosDps = [];
      
      this.limparDadosNotaFiscal();

      if (limparLote) {
        this.loteNotas = [];
      }

      //window.scrollTo({ top: 0, behavior: "smooth" });
      document.getElementById("topo").scrollIntoView({
        behavior: "smooth",
      });
    },

    copiarNotaFiscal() {
      var numero = null;

      if (this.notaFiscal && this.notaFiscal.numero) {
        numero = this.notaFiscal.numero;
      }
      const dados = {
        numero: numero,
        isEmissaoTesteValidacao: this.isEmissaoTesteValidacao
      };
      this.$root.$emit("notaFiscal:copiar", dados);
    },

    cancelarNotaFiscal() {
      //especifico joao monlevade
      let idCliente = '6866f81d-967e-4808-bb27-0dcf85594275';//""
      let cancelamentoCienciaTomador = (this.currentUser.configuracao.nfCancelamentoCienciaTomador && this.currentUser.configuracao.nfCancelamentoCienciaTomador === 'S')|| false;
      if(cancelamentoCienciaTomador && this.currentUser.usuario.idCliente === idCliente){
        var totalDiasCancelamento = 60;
        let dataEmissao = this.moment(this.notaFiscal.dataFatoGerador).format("YYYY-MM-DD");
        var dataLimiteCancelamento = new Date(dataEmissao);
        dataLimiteCancelamento.setDate(dataLimiteCancelamento.getDate() + totalDiasCancelamento);
        var dataAtual = new Date();
        if (dataAtual > dataLimiteCancelamento) {
          this.$toast.add({
            severity: 'warn',
            summary: 'Cancelamento Não Permitido',
            detail: 'O prazo de 60 dias para Cancelamento da Nota Fiscal foi excedido. Não é possível Cancelar ou emitir Termo de Cancelamento para essa Nota Fiscal.',
            life: 10000
          });
          return;
        }
      }
      if (this.notaFiscal && this.notaFiscal.id) {
        const notaFiscal = {
          id: this.notaFiscal.id,
          dataGeracao: this.moment(this.notaFiscal.dataFatoGerador).format(
            "YYYY-MM-DD"
          ),
          validacao: false,
          cancDamPetrolina: false,
          isEmissaoTesteValidacao: this.isEmissaoTesteValidacao
        };

        this.$root.$emit("notaFiscal:cancelar", notaFiscal);
      }
    },

    emitirNotaDps() {
      this.visivelVisualizacaoIbsCbs = false;
      this.salvar();
    },

    abrirVisualizacaoIbsCbs() {
      this.setarDadosNotaFiscal();

      if (this.selectedTipoTomador && this.selectedTipoTomador.key !== 'N' && !this.notaFiscal.idTomadorDados) {
        this.$root.$emit("alert:warn", "Preencha o Tomador da Nota para visualizar a NFS-e.");
        return;
      }
      if (!this.notaFiscal.idServicoItem) {
        this.$root.$emit("alert:warn", "Preencha o Serviço Municipal para visualizar a NFS-e.");
        return;
      }
      if (!this.notaFiscal.idServicoNacional) {
        this.$root.$emit("alert:warn", "Preencha o Serviço Nacional para visualizar a NFS-e.");
        return;
      }
      if (!this.notaFiscal.codigoNbs) {
        this.$root.$emit("alert:warn", "Preencha o NBS para visualizar a NFS-e.");
        return;
      }
      if (!this.notaFiscal.codigoIndop) {
        this.$root.$emit("alert:warn", "Preencha o Indicador de Operação para visualizar a NFS-e.");
        return;
      }
      if (!this.notaFiscal.codigoClasstrib) {
        this.$root.$emit("alert:warn", "Preencha a Classificação Tributária para visualizar a NFS-e.");
        return;
      }
      if (!this.notaFiscal.valorServico || this.notaFiscal.valorServico <= 0) {
        this.$root.$emit("alert:warn", "Preencha o Valor do Serviço com um valor maior que 0 para visualizar a NFS-e.");
        return;
      }

      this.reqIbsCbs = {
        idCliente: this.currentUser.usuario.idCliente,
        dhEmi: this.moment(this.notaFiscal.dataFatoGerador).format("YYYY-MM-DDTHH:mm:ssZ"),
        codigoMunic: this.codigoIbgePrincipal,
        codigoNbs: this.notaFiscal.codigoNbs,
        codigoIndop: this.notaFiscal.codigoIndop,
        codigoClasstrib: this.notaFiscal.codigoClasstrib,
        valorServico: this.notaFiscal.valorServico,
        descontoIncondicionado: this.notaFiscal.valorDescontoIncond,
        vPis: this.notaFiscal.valorPis,
        vCofins: this.notaFiscal.valorCofins,
        vlrIss: this.notaFiscal.valorIss
      };

      this.visivelVisualizacaoIbsCbs = true;
    },

    enviarEmailNotaFiscal() {
      if (this.notaFiscal && this.notaFiscal.id) {
        this.$root.$emit("notaFiscal:enviarEmail", this.notaFiscal.id);
      }
    },

    limparDadosNotaFiscal() {
      this.codigoIbgeVal = null;
      this.listaChaveNFse = [];
      this.chaveNfseNacional = null;
      this.selectedExportacao = null;
      this.habilitarSelecaoObra = false;
      this.selectedPais = null;
      this.selectedDpsId = null;
      this.errosDps = [];
      this.chaveAcesso = null;
      this.notaFiscal = new NotaFiscal();

      this.limparDadosImpostosFederais();
      this.notaAvulsa = this.currentUser.emiteNotaAvulsa;
      //console.log("Emite nfs Avulsa: " + this.currentUser.emiteNotaAvulsa);

      this.notaFiscal.notaAvulsa = this.notaAvulsa ? "S" : "N";

      this.notaFiscal.idCliente = this.currentUser.usuario.idCliente;
      this.notaFiscal.idUsuario = this.currentUser.usuario.idUsuario;
      this.notaFiscal.codigoIbgeCliente = this.currentUser.configuracao.codigoIbgeCliente;
      this.notaFiscal.siglaIbgeCliente = this.currentUser.configuracao.siglaIbgeCliente;
      this.notaFiscal.idCntPrestador =
        this.currentUser.contribuinte.idContribuinte;
      this.notaFiscal.dataFatoGerador = new Date();
      if(this.observacaoClienteNfse){
        this.notaFiscal.observacao =
          this.currentUser.contribuinteConfig.descServicosPadrao;
      }
      if(this.currentUser.contribuinteConfig.discServicosPadrao){
        this.notaFiscal.discriminacaoServico =
          this.currentUser.contribuinteConfig.discServicosPadrao;
      }

      this.selectedExportacao = this.tiposExportacao[0];
      this.selectedTipoTomador = this.tiposTomador[0];
      this.selectedLocalPrestacao = this.locaisPrestacao[0];
      this.selectedTipoRecolhimento = this.tiposRecolhimento[0];
      this.selectedTipoContrSociais = this.tiposContrSociais[0];
      this.selectedCompraGovernamental = this.tipoCompraGovernamental[0];
      this.selectedEnteGovernamental = this.tiposEnteGovernamental[0];
      this.selectedOperacaoGovernamental = this.tiposOpGovernamental[0];

      this.selectedModoPrestacao = null;
      this.selectedVinculoPrestacao = null;
      this.selectedMecanismoApoioPrestador = null;
      this.selectedMecanismoApoioTomador = null;
      this.selectedMovimentacaoTemporariaBens = null;
      this.selectedIndicadorEnvioMdic = null;
      this.validarComex = false;

      this.selectedMunicPrestacao = null;
      this.selectedPessoa = "";
      this.selectedPessoaIntermediario = "";
      this.selectedAtividade = null;
      this.selectedServico = null;
      this.selectedServicoNacional = null;
      this.selectedNbs = null;
      this.selectedIndop = null;
      this.selectedClasstrib = null;
      this.selectedObra = null;
      this.selectedImovel = null;
      this.habilitarSelecaoObra = false;

      this.municipioIncidencia = "";
      this.notaFiscal.idMunicIncidencia = null;
      this.searchLocalidadePorId(
        this.currentUser.configuracao.idCepLocalidadeCliente,
        true
      );
      
    },

    limparDadosImpostosFederais() {
      this.paramImpFederalDependentes = 0;
      this.paramImpFederalPercIRRF = 0;
      this.paramImpFederalPercINSS = 0;
      this.paramImpFederalAliqSEST = 0;
      this.paramImpFederalAliqSENAT = 0;
      this.outImpFederalBaseIRRF = 0;
      this.outImpFederalAliqIRRF = 0;
      this.outImpFederalBaseINSS = 0;
      this.outImpFederalAliqINSS = 0;
    },
    alterarTipoDps(){
      let idNotaSubstituida = this.notaFiscal.idNotaSubstituida;
      this.novaNotaFiscal();
      if(idNotaSubstituida){
        this.notaFiscal.idNotaSubstituida = idNotaSubstituida;
      }
    },
    alterarTipoTomador() {
      this.selectedPessoa = null;
      this.selectedPessoaIntermediario = null;
      this.selectedPessoaDestinatario = null;
      this.atualizarDadosTela();
    },

    alterarTipoIntermediario() {
      this.selectedPessoaIntermediario = null;
    },

    alterarTipoDestinatario() {
      this.selectedPessoaDestinatario = null;
    },

    novoTomador() {
      this.$root.$emit("notaFiscal:novoTomador");
    },

    editarTomador() {
      this.$root.$emit("notaFiscal:editarTomador");
    },

    removerTomador() {
      this.$root.$emit("notaFiscal:removerTomador", this.selectedPessoa);
    },

    novaObra() {
      this.$root.$emit("notaFiscal:novaObra");
    },

    novoImovel() {
      this.$root.$emit("notaFiscal:novoImovel");
    },

    editarObra() {
      this.$root.$emit("notaFiscal:editarObra");
    },

    editarImovel() {
      this.$root.$emit("notaFiscal:editarImovel");
    },

    removerObra() {
      this.$root.$emit("notaFiscal:removerObra");
    },

    removerImovel() {
      this.$root.$emit("notaFiscal:removerImovel");
    },

    novoIntermediario() {
      this.$root.$emit("notaFiscal:novoIntermediario");
    },

    editarIntermediario() {
      this.$root.$emit("notaFiscal:editarIntermediario");
    },

    removerIntermediario() {
      this.$root.$emit("notaFiscal:removerIntermediario", this.selectedPessoaIntermediario);
    },

    novoDestinatario() {
      this.$root.$emit("notaFiscal:novoDestinatario");
    },

    editarDestinatario() {
      this.$root.$emit("notaFiscal:editarDestinatario");
    },

    removerDestinatario() {
      this.$root.$emit("notaFiscal:removerDestinatario", this.selectedPessoaDestinatario);
    },

    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },

    verificaDamGerado() {
      if (this.notaFiscal.id != null) {
        this.processando(true);
        //console.log("Verifica Dam Gerado!!" + this.notaFiscal.id);
        NotaFiscalAvulsaService.verificaDamGerado(this.notaFiscal.id)
          .then(
            (response) => {
              this.damGerado = response.data;
              console.log(response);
            },
            (error) => {
              this.$root.$emit("alert:warn", "Erro ao verificar DAM!");
              this.damGerado = "N";
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
    },
    gerarDamNotaAvulsa() {
      this.gerarDamNotaAvulsaAcao(false);
    },
    gerarDamNotaAvulsaAcao(gerarAposEmissao) {
      if (!this.dataVencimento) {
        this.$root.$emit("alert:warn", "Data de Vencimento Obrigatória!");
        return;
      }

      this.processando(true);
      if (this.notaFiscal.id != null) {
        /*console.log(
          "Gerar DAM nf: " +
          this.notaFiscal.id +
          " Vencimento: " +
          this.dataVencimento
        );*/
        NotaFiscalAvulsaService.gerarDamNotaAvulsa(
          this.notaFiscal.id,
          this.dataVencimento
        )
          .then(
            (response) => {
              if(gerarAposEmissao){
                this.displayDevedorContumaz = false;
                this.displayVencBoleto = true;
                this.$root.$emit("alert:warn", this.avisoDevedorContumaz+" Realize a impressão do DAM");
              }else{
                  this.$root.$emit("alert:success", "DAM gerado com sucesso!");
              }
              console.log(response);
            },
            (error) => {
              this.$root.$emit("alert:warn", "Erro ao gerar o DAM!");
              console.log(error);
            }
          )
          .then(() => {
            this.verificaDamGerado();
            this.processando(false);
          });
      }
    },
    cancelarDamNotaAvulsa() {
      this.processando(true);
      //console.log("Cancelar DAM nf: " + this.notaFiscal.id);
      NotaFiscalAvulsaService.cancelarDamNotaAvulsa(this.notaFiscal.id)
        .then(
          (response) => {
            this.$root.$emit("alert:success", "DAM cancelado com sucesso!");
            console.log(response);
          },
          (error) => {
            this.$root.$emit("alert:warn", "Erro ao cancelar o DAM!");
            console.log(error);
          }
        )
        .then(() => {
          this.verificaDamGerado();
          this.processando(false);
        });
    },
    carregarVencimentoBoleto() {
      if (this.notaFiscal.id != null) {
        let d = this.currentUser.configuracao.diaVencimento;
        let arrayOfData = this.notaFiscal.dataFatoGerador.split("-");
        let dataEmissao = new Date(arrayOfData[0], arrayOfData[1] - 1, d);
        let dataAtual = new Date();
        let data = new Date(
          dataEmissao.getFullYear(),
          dataEmissao.getMonth(),
          d
        );
        let mes = data.getMonth() + 1;
        data.setMonth(mes);
        if (dataAtual > data) {
          this.dataVencimento = dataAtual;
        } else {
          this.dataVencimento = data;
        }

        this.verificaDamGerado();
        this.displayVencBoleto = true;
      }
    },
    hideVencBoleto() {
      this.displayVencBoleto = false;
    },
    imprimirBoleto() {
      if (!this.dataVencimento) {
        this.$root.$emit("alert:warn", "Data de Vencimento Obrigatória!");
        return;
      }
      this.processando(true);
      NotaFiscalAvulsaService.atualizarVencimento(
        this.notaFiscal.id,
        this.dataVencimento
      )
        .then(
          (response) => {
            console.log(response.data);
            let idGerado = response.data;
            ReportService.imprimir("trb_dam_a5", [
              {
                param: "RP_ID_CLIENTE",
                string: this.currentUser.usuario.idCliente,
              },
              {
                param: "P_CONTROLE_PARCELA",
                string:
                  " and cp.id_situacao in('1','4','6')  and  cp.id in ('" +
                  idGerado +
                  "')",
              },
            ]).then(
              (data) => {
                console.log(data);
              },
              (error) => {
                this.$root.$emit(
                  "alert:warn",
                  "Erro ao exibir a visualização!"
                );
                console.log(error);
              }
            );
          },
          (error) => {
            this.$root.$emit("alert:warn", "Erro ao atualizar Vencimento!");
            console.log(error);
          }
        )
        .then(() => {
          this.hideVencBoleto();
          this.processando(false);
        });
    },
    criarPagamentoPix() {
      this.processando(true);
      NotaFiscalAvulsaService.criarPagamentoPix(this.notaFiscal.id)
        .then(
          (response) => {
            console.log(response);
            this.pixGerado = response.data;
            this.optionsPix.data = this.pixGerado.qrCode;
            this.showPix = true;
          },
          (error) => {
            this.pixGerado = null;
            this.$root.$emit("alert:warn", error);
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    consultarPagamentoPix() {
      if (this.notaFiscal.id) {
        this.processando(true);
        NotaFiscalAvulsaService.consultarPagamentoPix(this.notaFiscal.id)
          .then(
            (response) => {
              console.log(response);
              this.hideVencBoleto();
              this.showPix = false;
              this.$root.$emit("alert:info", response.data);
            },
            (error) => {
              console.log(error);
              this.$root.$emit("alert:warn", error.response.data);
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
    },
    imprimirBoletoPix() {
      if (!this.dataVencimento) {
        this.$root.$emit("alert:warn", "Data de Vencimento Obrigatória!");
        return;
      }
      this.processando(true);
      NotaFiscalAvulsaService.atualizarVencimento(
        this.notaFiscal.id,
        this.dataVencimento
      )
        .then(
          (response) => {
            console.log(response);
            let idGerado = response.data;
            NotaFiscalAvulsaService.criarPagamentoPixCp(
              this.notaFiscal.id,
              idGerado
            )
              .then(
                (response) => {
                  console.log(response);
                  this.pixGerado = response.data;
                  ReportService.imprimir("trb_dam_a5_pix", [
                    {
                      param: "RP_ID_CLIENTE",
                      string: this.currentUser.usuario.idCliente,
                    },
                    {
                      param: "QR_CODE",
                      string: this.pixGerado.qrCode,
                    },
                    {
                      param: "P_CONTROLE_PARCELA",
                      string:
                        " and cp.id_situacao in('1','4','6')  and  cp.id in ('" +
                        idGerado +
                        "')",
                    },
                  ]).then(
                    (data) => {
                      console.log(data);
                    },
                    (error) => {
                      this.$root.$emit(
                        "alert:warn",
                        "Erro ao exibir a visualização!"
                      );
                      console.log(error);
                    }
                  );
                },
                (error) => {
                  this.pixGerado = null;
                  this.$root.$emit("alert:warn", error);
                  console.log(error);
                }
              )
              .then(() => {
                this.showEscolhaPix = false;
                this.processando(false);
              });
          },
          (error) => {
            this.$root.$emit("alert:warn", "Erro ao atualizar Vencimento!");
            console.log(error);
          }
        )
        .then(() => {
          this.hideVencBoleto();
          this.processando(false);
        });
    },
    aplicarImpFederais(){
      if(this.confImpFederais && this.confImpFederais.id && this.notaFiscal.valorServico && this.notaFiscal.valorServico > 0){
        this.notaFiscal.valorPis = ((this.confImpFederais.aliquotaPis * this.notaFiscal.valorServico) / 100.0);
        this.notaFiscal.valorIr = ((this.confImpFederais.aliquotaIr * this.notaFiscal.valorServico) / 100.0);
        this.notaFiscal.valorInss = ((this.confImpFederais.aliquotaInss * this.notaFiscal.valorServico) / 100.0);
        this.notaFiscal.valorCsll = ((this.confImpFederais.aliquotaCsll * this.notaFiscal.valorServico) / 100.0);
        this.notaFiscal.valorCofins = ((this.confImpFederais.aliquotaCofins * this.notaFiscal.valorServico) / 100.0);
      }
    },

    aplicarImpFederaisPadrao() {
      this.confImpFederais = JSON.parse(JSON.stringify(this.currentUser.confImpFederais));
      //console.log(this.confImpFederais.aliquotaPis);
      this.aplicarImpFederais();
    },
    limparImpFederaisPadrao() {
      this.confImpFederais.aliquotaPis = 0;
      this.confImpFederais.aliquotaIr = 0;
      this.confImpFederais.aliquotaInss = 0;
      this.confImpFederais.aliquotaCsll = 0;
      this.confImpFederais.aliquotaCofins = 0;
      this.aplicarImpFederais();
    },
    openDialogImpFederais() {
      this.showDialogImpFederais = true;
    },
    closeDialogImpFederais() {
      this.showDialogImpFederais = false;
    },
    calcularImpostosFederais() {
      this.processando(true);

      if (!this.paramImpFederalDependentes) {
        this.paramImpFederalDependentes = 0;
      }

      NotaFiscalAvulsaService.calcularImpostosFederais(
        this.notaFiscal.dataFatoGerador.getFullYear(),
        this.notaFiscal.dataFatoGerador.getMonth() + 1, // O getMonth busca valor de 0 a 11
        this.baseCalculo,
        this.paramImpFederalDependentes,
        this.notaFiscal.valorDeducaoPreviaInss,
        this.paramImpFederalPercIRRF ,
        this.paramImpFederalPercINSS,
        this.paramImpFederalAliqSEST,
        this.paramImpFederalAliqSENAT
      )
        .then(
          (response) => {
            let impostosFederais = response.data;
            this.outImpFederalBaseIRRF = impostosFederais.baseCalculoIrrf;
            this.outImpFederalAliqIRRF = impostosFederais.aliquotaIrrf;
            this.outImpFederalBaseINSS = impostosFederais.baseCalculoInss;
            this.outImpFederalAliqINSS = impostosFederais.aliquotaInss;

            this.notaFiscal.valorIrrf = impostosFederais.valorIrrf;
            this.notaFiscal.valorInss = impostosFederais.valorInss;
            this.notaFiscal.valorSest = impostosFederais.valorSest;
            this.notaFiscal.valorSenat = impostosFederais.valorSenat;

            this.$root.$emit("alert:success", "Impostos Federais calculados com sucesso! Retorne à edição da Nota Fiscal após conferência dos valores.");
            console.log(impostosFederais);
          },
          (error) => {
            this.$root.$emit("alert:warn", "Erro ao calcular Impostos Federais!");
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    roundToTwoDecimalPlaces(number) {
      return Math.round(number * 100) / 100;
    },
    adicionarNotaLote() {
      this.processando(true);
      this.setarDadosNotaFiscal();

      NotaFiscalService.validar(this.notaFiscal, this.selectedTipoTomador.key)
        .then(
          (data) => {
            this.notaFiscal = data.data;
            this.notaFiscal.detailServico = this.selectedServico.detail;
            this.notaFiscal.codigoServico = this.selectedServico.codigoServico;
            this.notaFiscal.nomeServico = this.selectedServico.nomeServico;
            this.notaFiscal.hashLote = Date.now();
            this.loteNotas.push(this.notaFiscal);

            //Salva dados do Tomador/Intermediário antes de limpar os dados da tela
            var tp = this.selectedTipoTomador;
            var sp = this.selectedPessoa;
            var si = this.selectedPessoaIntermediario;

            this.novaNotaFiscal(false);

            this.selectedTipoTomador = tp;
            this.selectedPessoa = sp;
            this.selectedPessoaIntermediario = si;

            this.$root.$emit("alert:info", "A Nota Fiscal foi adicionada ao Lote!");
          },
          (error) => {
            const erros = error.response.data;
            this.erros.push(...erros);

            if (!erros.length) {
              this.$root.$emit(
                "alert:error",
                "Houve um problema ao adicionar a Nota Fiscal ao Lote!"
              );
            }
          }
        )
        .then(() => {
          this.processando(false);
        }
      );
    },
    salvarLote() {
      this.processando(true);
      this.erros = [];

      NotaFiscalService.saveLote(this.loteNotas, this.selectedTipoTomador.key)
        .then(
          (data) => {
            this.loteNotas = data.data;
            this.loteNotas = this.loteNotas.filter(nota => !('id' in nota && nota.id !== null));

            this.verificarLoteVazio();
            this.$root.$emit("alert:success", "O Lote foi processado e as Notas Fiscais foram salvas!");

            //No método de salvar "normal" aqui vão as validações de Nota Avulsa acumulada e Devedor Costumaz...
          },
          (error) => {
            // const loteNotas = error.response.data;
            // console.log(loteNotas);
            //this.erros.push(...erros);
            // this.$root.$emit("alert:error", "Erro ao salvar uma ou mais Notas Fiscais no Lote!");
            let errorMessage = "Houve um problema ao salvar a configuracao!";
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail: errorMessage,
              life: 5000
            });
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    removerNotaLote(hashLote) {
      this.loteNotas = this.loteNotas.filter(nota => nota.hashLote !== hashLote);
      this.$root.$emit("alert:info", "A Nota Fiscal foi removida do Lote!");
      this.verificarLoteVazio();
    },
    exibirLoteNotas() {
      this.showLote = true;
    },
    ocultarLoteNotas() {
      this.showLote = false;
    },
    verificarLoteVazio(){
      //Se não houver mais notas na lista, fecha a tela.
      if (this.loteNotas.length == 0) {
        this.novaNotaFiscal();
        this.ocultarLoteNotas();
      }
    },
    classeErroTabelaLote(data) {
      return data.erros && data.erros.length > 0 ? 'red-text' : '';
    },
    exibeErroTabelaLote() {
      return this.loteNotas.some(nota => Array.isArray(nota.erros) && nota.erros.length > 0);
    },
    formatarMensagemErro(mensagem) {
      if (!mensagem) return "";
      if (typeof mensagem === "string") return mensagem;
      try {
        return Object.entries(mensagem)
          .map(([key, val]) => `${key}: ${typeof val === "object" ? JSON.stringify(val) : val}`)
          .join("\n");
      } catch (e) {
        return JSON.stringify(mensagem);
      }
    },
    
    obterTitulo() {
      if (this.testeValidacao) {
        return 'Declaração de Prestação de Serviço Eletrônica';
      }
      if (this.notaAvulsa) {
        return 'Emissão de Notas Fiscais Avulsas Eletrônicas.';
      }
      if (this.isEmissaoLote) {
        return 'Emissão em Lote de Notas Fiscais de Serviço Eletrônicas';
      }
      return 'Emissão de Notas Fiscais de Serviço Eletrônicas';
    },

    obterSubtitulo() {
      const tipoEmissao = this.testeValidacao ? 'DPS (Teste e Validação)' : 'Nota Fiscal';
      const tipoNota = !this.notaAvulsa ? tipoEmissao : tipoEmissao + ' Avulsa';
      let acao = '';
      if (this.isEmissaoLote) {
        acao = 'Emissão em Lote';
      } else {
        acao = 'Emissão';
      }
      return `${tipoNota} > ${acao}`;
    },

    indopSelecionado(){
      //limpa o identificador do imovel pois caso troque o indop pra um que não pode imovel a variavel esteja inicializada
      this.selectedImovel = null;
    },

    carregarCombosComercioExterior() {
      NotaFiscalNacionalService.obterModoPrestacao()
        .then(response => {
          this.modosPrestacao = response.data || [];
        })
        .catch(err => {
          console.error("Erro ao obterModoPrestacao", err);
        });

      NotaFiscalNacionalService.obterVinculoPrestacao()
        .then(response => {
          this.vinculosPrestacao = response.data || [];
        })
        .catch(err => {
          console.error("Erro ao obterVinculoPrestacao", err);
        });

      NotaFiscalNacionalService.obterMecanismoApoioPrestador()
        .then(response => {
          this.mecanismosApoioPrestador = response.data || [];
        })
        .catch(err => {
          console.error("Erro ao obterMecanismoApoioPrestador", err);
        });

      NotaFiscalNacionalService.obterMecanismoApoioTomador()
        .then(response => {
          this.mecanismosApoioTomador = response.data || [];
        })
        .catch(err => {
          console.error("Erro ao obterMecanismoApoioTomador", err);
        });

      NotaFiscalNacionalService.obterMovimentacaoTemporariaBens()
        .then(response => {
          this.movimentacoesTemporariaBens = response.data || [];
        })
        .catch(err => {
          console.error("Erro ao obterMovimentacaoTemporariaBens", err);
        });

      NotaFiscalNacionalService.obterIndicadorEnvioMdic()
        .then(response => {
          this.indicadoresEnvioMdic = response.data || [];
        })
        .catch(err => {
          console.error("Erro ao obterIndicadorEnvioMdic", err);
        });
    }
  },

  computed: {
    exibirComercioExterior() {
      if (!this.isEmissaoPorDPS) {
        return false;
      }
      const tomadorExterior = !!(this.selectedTipoTomador && this.selectedTipoTomador.key === 'E');
      const prestacaoExterior = (this.codigoIbgeVal == 9999999) ||
        !!(this.selectedMunicPrestacao && (
          this.selectedMunicPrestacao.codigoIbge == 9999999 ||
          this.selectedMunicPrestacao.codigoIbge === '9999999' ||
          (typeof this.selectedMunicPrestacao === 'string' && this.selectedMunicPrestacao.includes('9999999'))
        ));
      return tomadorExterior || prestacaoExterior;
    },
    isBloqueado() {
      return this.currentUser && this.currentUser.idBolBloquearSistema && this.currentUser.idBolBloquearSistema === 'S';
    },
    dadosPrestador() {
      if (this.currentUser) {
        let contribuinte = this.currentUser.contribuinte || {};
        let cpfCnpj = contribuinte.cpfCnpj || contribuinte.documento || '';
        let nome = contribuinte.razaoSocial || contribuinte.nome || (this.currentUser.usuario ? this.currentUser.usuario.nome : '');
        let inscricaoMunicipal = contribuinte.inscricaoMunicipal || contribuinte.inscMunic || '';
        let cep = contribuinte.cep || '';
        let municipio = contribuinte.municipioDescricao || contribuinte.municipio || '';
        let estado = contribuinte.estadoSigla || contribuinte.estado || '';
        let bairro = contribuinte.bairro || '';
        let logradouro = contribuinte.logradouro || '';
        let numero = contribuinte.numero || '';

        return {
          documento: cpfCnpj,
          nome: nome,
          inscricaoMunicipal: inscricaoMunicipal,
          cep: cep,
          municipio: municipio,
          estado: estado,
          bairro: bairro,
          logradouro: logradouro,
          numero: numero
        };
      }
      return { documento: '', nome: '', inscricaoMunicipal: '', cep: '', municipio: '', estado: '', bairro: '', logradouro: '', numero: '' };
    },

    informacoesExtrasIbsCbs() {
      const getMunicDetail = (munic) => {
        if (!munic) return '';
        if (typeof munic === 'string') return munic;
        if (munic.detail) return munic.detail;
        
        const nomeOuDesc = munic.descricao || munic.nome || munic.municipioDescricao;
        if (nomeOuDesc && munic.uf) {
           return munic.codigoIbge ? `${munic.codigoIbge} - ${nomeOuDesc} - ${munic.uf}` : `${nomeOuDesc} - ${munic.uf}`;
        }
        return nomeOuDesc || '';
      };

      return {
        tipoEmissao: 'PRESTADOR/FORNECEDOR',
        isDestinatarioAdquirente: this.selectedTipoDestinatario ? this.selectedTipoDestinatario.name : 'SIM',
        tributacaoIssqn: this.selectedTipoTributacao ? this.selectedTipoTributacao.name : 'Operação Tributável',
        regimeEspecial: this.selectedRegimeEspecial ? this.selectedRegimeEspecial.name : 'Nenhum',
        exigibilidadeSuspensa: this.selectedExigibilidadeSuspensa ? this.selectedExigibilidadeSuspensa.name : 'Não',
        retencaoIssqn: this.selectedTipoRecolhimento && this.selectedTipoRecolhimento.key === 'R' ? 'Sim' : 'Não',
        amparadoBeneficio: this.dadosTela && this.dadosTela.idBeneficio ? 'Sim' : 'Não',
        tipoDeducao: this.notaFiscal && this.notaFiscal.valorDesconto > 0 ? 'Sim' : 'Não',
        situacaoPisCofinsCsll: this.selectedTipoContrSociais ? this.selectedTipoContrSociais.name : '00 - Nenhum',
        descContribuicoesSociais: this.selectedTipoContrSociais ? this.selectedTipoContrSociais.name : '0 - PIS/COFINS/CSLL Não Retidos',
        ufPrestacao: this.selectedLocalPrestacao && this.selectedLocalPrestacao.key === 'F' && this.selectedPais ? (this.selectedPais.detail || this.selectedPais) : (this.selectedMunicPrestacao ? getMunicDetail(this.selectedMunicPrestacao) : getMunicDetail(this.selectedMunicOrigem)),
        ufIncidencia: this.municipioIncidencia ? this.municipioIncidencia : (this.selectedMunicPrestacao ? getMunicDetail(this.selectedMunicPrestacao) : getMunicDetail(this.selectedMunicOrigem)),
        nbsDetalhe: this.selectedNbs ? this.selectedNbs.detail : '',
        indopDetalhe: this.selectedIndop ? this.selectedIndop.detail : ''
      };
    },

    totalServico: {
      get() {
        return (
          this.notaFiscal.valorServico -
          this.notaFiscal.valorDesconto -
          this.notaFiscal.valorDescontoIncond
        );
      },
      set(val) {
        this.valorTotalServico = val;
      },
    },

    totalIss: {
      get() {
        let aliquota = Number(this.notaFiscal.aliquota.toFixed(2));
        let resultado;
        if(this.selectedTipoRecolhimento && this.selectedTipoRecolhimento.key === "S"){
          resultado = 0;
        }else{
          resultado = this.roundToTwoDecimalPlaces(this.baseCalculo * aliquota / 100.0);
        }
        return resultado;
      },
      set(val) {
        this.valorTotalIss = val;
      },
    },

    baseCalculo: {
      get() {
        return (
          Number((this.notaFiscal.valorServico -
          this.notaFiscal.valorDesconto -
          this.notaFiscal.valorDescontoIncond).toFixed(2))
        );
      },
    },

    valorLiquido: {
      get() {
        let isEmissaoDps = this.isEmissaoTesteValidacao || this.isEmissaoPorDPS;
        let isImpostosFederaisNaoRetidos = this.currentUser && this.currentUser.contribuinteConfig && this.currentUser.contribuinteConfig.idBolImpostosFederaisNaoRetidos === 'S';
        
        let pis = (isImpostosFederaisNaoRetidos || isEmissaoDps) ? 0 : this.notaFiscal.valorPis;
        let cofins = (isImpostosFederaisNaoRetidos || isEmissaoDps) ? 0 : this.notaFiscal.valorCofins;
        let csll = (isImpostosFederaisNaoRetidos || isEmissaoDps) ? 0 : this.notaFiscal.valorCsll;
        
        let retencaoSocialDps = 0;
        if (isEmissaoDps && this.selectedTipoContrSociais && this.selectedTipoContrSociais.key !== '0' && this.notaFiscal.valorContribuicaoSocial) {
          retencaoSocialDps = this.notaFiscal.valorContribuicaoSocial;
        }

        return (
          this.notaFiscal.valorServico -
          pis -
          cofins -
          this.notaFiscal.valorInss -
          this.notaFiscal.valorIr -
          csll -
          retencaoSocialDps -
          (this.selectedTipoRecolhimento.key == "R" ? this.totalIss : 0) -
          this.notaFiscal.valorDescontoIncond -
          this.notaFiscal.valorDescontoCond -
          this.notaFiscal.valorDescontosDiversos -
          this.notaFiscal.outrasRetencoes
        );
      },
    },

    desabilitarEdicaoCampos() {
      return this.notaFiscal && this.notaFiscal.id ? true : false;
    },

    desabilitarEdicaoCamposImpostosFederais() {
      return this.habilitarCalculoImpostosFederais
        ? true
        : false;
    },

    desabilitarEdicaoNomeTomador() {
      return this.desabilitarEdicaoCampos || this.selectedTipoTomador.key == "N"
        ? true
        : false;
    },

    desabilitarEdicaoLocalPrestacao() {
      return this.desabilitarEdicaoCampos || this.selectedTipoTomador.key == "N"
        ? true
        : false;
    },

    desabilitarEdicaoMunicipio() {
      return this.desabilitarEdicaoCampos ||
        this.selectedLocalPrestacao.key == "M"
        ? true
        : false;
    },

    desabilitarEdicaoAliquota() {
      return !!(this.dadosTela && this.dadosTela.desabilitarEdicaoAliquota) ||
        this.desabilitarEdicaoCampos
        ? true
        : false;
    },

    desabilitarEdicaoDeducao() {
      return !!(this.dadosTela && this.dadosTela.desabilitarEdicaoDeducao) ||
        this.desabilitarEdicaoCampos
        ? true
        : false;
    },

    desabilitarEdicaoDescIncond() {
      return this.dadosTela &&
        !this.dadosTela.desabilitarEdicaoDescIncond &&
        !this.desabilitarEdicaoCampos
        ? false
        : true;
    },

    desabilitarEdicaoNotaAvulsa() {
      return this.desabilitarEdicaoCampos || this.notaAvulsa ? true : false;
    },

    desabilitarDadosObra() {
      return !(this.exibirDadosObra && this.exibirDadosObra == "S") ||
        this.desabilitarEdicaoCampos || (this.selectedObra && this.selectedObra.id)
        ? true
        : false;
    },


    exibirDadosNotaSubstituida() {
      return this.notaFiscal && this.notaFiscal.idNotaSubstituida
        ? true
        : false;
    },

    exibirInfoDadosObra() {
      return this.exibirDadosObra == "S" ? true : false;
    },

    exibirOpcaoExportacao() {
      return this.selectedLocalPrestacao.key === 'M' && this.selectedTipoTomador.key === 'E'
    },

    exibirPaisExportacao() {
      return this.exibirOpcaoExportacao && this.selectedExportacao && this.selectedExportacao.key === 'S';
    },

    exibirSelecaoImovel() {
      //o imovel deve ser apresentado somente se não houver obra relacionada
      if (!this.habilitarSelecaoObra && this.selectedIndop && this.selectedIndop.codigoIndop && this.selectedIndop.codigoIndop.startsWith('020')) {
        return true;
      }
      return false;
    },

    exibirBotao() {
      const botoes = {
        novo: false,
        copiar: false,
        gravar: false,
        cancelar: false,
        imprimir: false,
        email: false,
      };

      let devedorCostumaz = this.currentUser && this.currentUser.contribuinte && this.currentUser.contribuinte.devedorCostumaz && this.currentUser.contribuinte.devedorCostumaz === 'S';

      botoes.novo = true;
      botoes.copiar = true;
      //console.log(this.disableCopiaNota);
      botoes.gravar = this.notaFiscal.id == null || this.notaFiscal.id == "";
      botoes.cancelar = this.notaFiscal.id != null && this.notaFiscal.id != "";
      botoes.imprimir =
        this.notaFiscal.id != null &&
        this.notaFiscal.id != "" &&
        (!this.notaAvulsa || this.notaFiscal.tipoRecolhimento === "R");
      botoes.email =
        this.notaFiscal.id != null &&
        this.notaFiscal.id != "" &&
        !this.notaAvulsa && 
        !devedorCostumaz;

      return botoes;
    },

    exibeIntermediario() {
      return this.selectedPessoa && this.currentUser.configuracao.idBolIntermediario && this.currentUser.configuracao.idBolIntermediario == "S";
    },

    exibirSelecaoIntermediario(){
      return this.exibeIntermediario && this.selectedTipoIntermediario.key === "S";
    },

    exibirSelecaoDestinatario(){
      return this.selectedTipoDestinatario.key === "N";
    },
    desabilitarBotaoNovoTomador() {
      return this.selectedTipoTomador.key == "N" || this.desabilitarEdicaoCampos
        ? true
        : false;
    },

    desabilitarBotaoEdicaoTomador() {
      return !this.selectedPessoa || this.desabilitarEdicaoCampos
        ? true
        : false;
    },

    desabilitarBotaoRemoverTomador() {
      return !this.selectedPessoa || this.desabilitarEdicaoCampos
        ? true
        : false;
    },
    desabilitarBotaoNovaObra() {
      return this.desabilitarEdicaoCampos
        ? true
        : false;
    },

    desabilitarBotaoNovaImovel() {
      return this.desabilitarEdicaoCampos
        ? true
        : false;
    },

    desabilitarBotaoEdicaoObra() {
      return !this.selectedObra || this.desabilitarEdicaoCampos
        ? true
        : false;
    },

    desabilitarBotaoEdicaoImovel() {
      return !this.selectedImovel || this.desabilitarEdicaoCampos
        ? true
        : false;
    },

    desabilitarBotaoRemoverObra() {
      return !this.selectedObra || this.desabilitarEdicaoCampos
        ? true
        : false;
    },

    desabilitarBotaoRemoverImovel() {
      return !this.selectedImovel || this.desabilitarEdicaoCampos
        ? true
        : false;
    },

    desabilitarBotaoNovoIntermediario() {
      return this.desabilitarEdicaoCampos
        ? true
        : false;
    },

    desabilitarBotaoEdicaoIntermediario() {
      return !this.selectedPessoaIntermediario || this.desabilitarEdicaoCampos
        ? true
        : false;
    },

    desabilitarBotaoNovoDestinatario() {
      return this.desabilitarEdicaoCampos
        ? true
        : false;
    },
     desabilitarBotaoEdicaoDestinatario() {
      return !this.selectedPessoaDestinatario || this.desabilitarEdicaoCampos
        ? true
        : false;
    },

    desabilitarBotaoRemoverIntermediario() {
      return !this.selectedPessoaIntermediario || this.desabilitarEdicaoCampos
        ? true
        : false;
    },

    desabilitarBotaoRemoverDestinatario() {
      return !this.selectedPessoaDestinatario || this.desabilitarEdicaoCampos
        ? true
        : false;
    },

    desabilitarBotaoCalculoImpostosFederais() {
      return !this.selectedServico || !this.baseCalculo || this.desabilitarEdicaoCampos
        ? true
        : false;
    },

    dataMinimaEmissao() {
      var data = new Date();
      let dias = 0;
      if(this.notaAvulsa){
         dias = this.currentUser.configuracao.nfDiasEmissaoRetroativaNfAvulsa;
      }else{
        dias = this.currentUser.configuracao.nfDiasEmissaoRetroativa;
      }
      

      if (dias > 0) {
        data.setDate(data.getDate() - dias);
      }

      return data;
    },

    dataMaximaEmissao() {
      return new Date();
    },

    isEmissaoLote() {
      return this.$route.name && this.$route.name == 'emissaoNfseLote'
    },

    isEmissaoTesteValidacao() {
      return this.testeValidacao
    },
    isEmissaoSoPorDPS() {
      if(this.currentUser && this.currentUser.configuracao && this.currentUser.configuracao.idBolHabilitarDpsProducao === "S"){
        return true;
      }
      return false;
    },
    isEmissaoPorDPS() {
      if(this.selectedTipoEmissaoDps && this.selectedTipoEmissaoDps.key === 'S'){
        return true;
      }else if(this.testeValidacao === true){
        return true;
      }else if(this.currentUser && this.currentUser.configuracao && this.currentUser.configuracao.idBolHabilitarDpsProducao === "S"){
        return true;
      }
      return false;
    },
    isHabilitarNotaNacional() {
        return this.testeValidacao === true ? true : (this.currentUser && this.currentUser.configuracao && this.currentUser.configuracao.idBolIntegraNfseNacional === "S");
    },

    quantidadeNotasLote() {
      return this.loteNotas.length ? this.loteNotas.length : 0;
    },

    travarCamposEmissaoLote(){
      return this.isEmissaoLote && this.quantidadeNotasLote > 0
    },

    exibirOperacaoGovernamental(){
      if(!this.isEmissaoPorDPS){
        return false;
      }
      let codigoServicoNacional = this.selectedServicoNacional && this.selectedServicoNacional.servicoNacional && this.selectedServicoNacional.servicoNacional.codigoServico ? this.selectedServicoNacional.servicoNacional.codigoServico : null;
      return (this.selectedCompraGovernamental && this.selectedCompraGovernamental.key === 'S') || (codigoServicoNacional && (codigoServicoNacional.startsWith('2505') || codigoServicoNacional.startsWith('1509') || codigoServicoNacional.startsWith('1712') || codigoServicoNacional.startsWith('1005')))
    }

  },

  validators: {
    // selectedPessoa: function(value) {
    //   return Validator.value(value).required("Necessário informar um Tomador");
    // },
    // "notaFiscal.aliquota": function(value) {
    //   return Validator.value(value).greaterThan(
    //     0,
    //     "Aliquota deve ser maior que zero se o tisadasd asd asd asdas "
    //   );
    // }
  },
};
</script>

<style lang="scss" scoped>

#dpsDadosId:focus {
  outline: none;
}

.p-inputtext {
  text-align: right;
}

.p-inputtext:disabled {
  color: #a6a6a6;
  border-color: #a6a6a6;
}

::deep(.red-text) {
  color: #dc3545 !important;
  font-weight: bold;
}

.mensagem-cancelamento {
  color: black;
  font-weight: bold;
}

textarea {
  width: 100%;
  border-radius: 12px;
}

/* Usando :deep para penetrar nos componentes filhos do Vue */
:deep(.p-calendar-w-btn .p-datepicker-trigger,
.p-calendar-w-btn .p-datepicker-trigger,) {
    height: 40px !important;
    border-radius: 0px 12px 12px 0px! important;
}

button.p-datepicker-trigger.p-button.p-component.p-button-icon-only {
  height: 40px !important;
  border-radius: 0px 12px 12px 0px! important;
}

:deep(.p-calendar-w-btn .p-datepicker-trigger:enabled:hover) {
    background: #116fbf !important;
    color: #ffffff !important;
    border-color: #116fbf !important;
}

/* Estilos base para todos os botões */
:deep(.p-button) {
  height: 40px;
  margin-right: 0.5rem;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s;
}

/* Estilo específico para botões primários */
// :deep(.p-button.p-button-primary) {
//   &:enabled:hover {
//     background: #116fbf;
//     color: #ffffff;
//     border-color: #116fbf;
//   }
// }

/* Estilo específico para botões success */
:deep(.p-button.p-button-success) {
  &:enabled:hover {
    background: #0d9f6e;
    color: #ffffff;
    border-color: #0d9f6e;
  }
}

/* Ajuste para o espaçamento dos ícones */
// :deep(.p-button-icon-left) {
// }

/* Garantir que o label fique alinhado corretamente */
:deep(.p-button-label) {
  font-weight: 500;
}

/* Estilos específicos para o botão do calendário */
:deep(.p-datepicker-trigger.p-button.p-component),
:deep(button.p-datepicker-trigger.p-button.p-component.p-button-icon-only) {
  height: 40px !important;
  border-radius: 0px 12px 12px 0px !important;
  margin: 0 !important;
  background: #007ad9 !important;
  border: 1px solid #007ad9 !important;
  color: #ffffff !important;

  &:enabled:hover {
    background: #116fbf !important;
    border-color: #116fbf !important;
  }

  .p-button-icon {
    font-size: 1rem !important;
  }
}

/* Ajuste para o container do calendário */
:deep(.p-calendar-w-btn) {
  .p-inputtext {
    border-radius: 12px 0 0 12px !important;
  }
}

::deep(.p-fluid .p-inputgroup .p-button.p-button-icon-only){
  margin-right: 0.5rem;
}

/* Ajuste para o espaçamento dos botões no inputgroup */
:deep(.p-inputgroup) {
  .p-button {
    margin-right: 0;  /* Remove margem entre os botões dentro do inputgroup */
  }
}

.erros-dps-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.erro-dps-card {
  border: 1px solid #f5c6cb;
  border-left: 5px solid #dc3545;
  background: linear-gradient(135deg, #fffcfc 0%, #fff5f5 100%);
  color: #721c24;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(220, 53, 69, 0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  padding: 16px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(220, 53, 69, 0.1);
  }
}

.erro-dps-header {
  border-bottom: 1px solid #fbd2d6;
  padding-bottom: 8px;
}

.erro-dps-code {
  font-size: 1.1em;
  color: #c82333;
  display: flex;
  align-items: center;

  i {
    font-size: 1.2em;
    margin-right: 8px;
  }
}

.erro-dps-desc {
  font-size: 1.05em;
  font-weight: 500;
  line-height: 1.5;
}

.erro-dps-comp {
  font-size: 0.95em;
  background-color: rgba(0, 0, 0, 0.02);
  padding: 8px 12px;
  border-radius: 6px;
  border-left: 3px solid #6c757d;
  color: #495057;
}

.erro-dps-msg {
  .msg-title {
    font-size: 0.9em;
    font-weight: bold;
    color: #495057;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .msg-content {
    margin-bottom: 0;
    background: #ffffff;
    border: 1px solid #e9ecef;
    padding: 10px;
    border-radius: 6px;
    font-size: 0.9em;
    white-space: pre-wrap;
    font-family: 'Courier New', Courier, monospace;
    color: #212529;
    max-height: 250px;
    overflow-y: auto;
  }
  .p-chip.custom-chip {
    background: var(--primary-color);
    color: var(--primary-color-text);
    padding: 3px;
  }
}

</style>